import 'isomorphic-fetch';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/esm/asyncToGenerator';
import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Date$now from '@babel/runtime-corejs3/core-js-stable/date/now';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import { base64Encode } from '@thisisbud/base64-utils';
import { joinUrlPaths, formatUrlSearchParams } from '@thisisbud/url-utils';
import { snakeCaseToKebabCase, formatSortCode, snakeCaseToCamelCase, kebabCaseToSnakeCase } from '@thisisbud/string-utils';
import { timeout } from '@thisisbud/timer-utils';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _reduceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _everyInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/every';
import { toUTCDateString, parseDate, addDuration } from '@thisisbud/datetime-utils';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.number.to-fixed.js';
import _padStartInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/pad-start';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import _parseFloat from '@babel/runtime-corejs3/core-js-stable/parse-float';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _sortInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/sort';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import 'core-js/modules/es.symbol.description.js';
import FormData$1 from 'form-data';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';

let host = '';
let pollingInterval = 500;
/**
 * Get the currently configured API host.
 *
 * @returns The host to use when making API requests
 * @public
 *
 * @example
 * ```javascript
 * import { getHost } from '@thisisbud/internal-sdk'
 *
 * const host = getHost()
 * // 'https://payments-merchant-proxy.thisisbud.com'
 * ```
 */
function getHost() {
  return host;
}
/**
 * Set a new API host to be used.
 *
 * @param value - The host to set
 * @public
 *
 * @example
 * ```javascript
 * import { setHost } from '@thisisbud/internal-sdk'
 *
 * setHost('https://payments-merchant-proxy.thisisbud.com')
 * ```
 */
function setHost(value) {
  host = value;
}
/**
 * Get the currently configured polling interval.
 * Some requests will require polling API endpoints until a condition is met.
 *
 * @returns The time interval in milliseconds to use when polling API endpoints
 * @public
 *
 * @example
 * ```javascript
 * import { getPollingInterval } from '@thisisbud/internal-sdk'
 *
 * const interval = getPollingInterval()
 * // 500
 * ```
 */
function getPollingInterval() {
  return pollingInterval;
}
/**
 * Set a new polling interval to be used.
 *
 * @param value - The polling interval to set
 * @public
 *
 * @example
 * ```javascript
 * import { setPollingInterval } from '@thisisbud/internal-sdk'
 *
 * setPollingInterval(250)
 * ```
 */
function setPollingInterval(value) {
  pollingInterval = value;
}

// Available API versions
var Version;
(function (Version) {
  Version["beta"] = "beta";
  Version["internal"] = "internal";
  Version["v1"] = "v1";
  Version["v2"] = "v2";
})(Version || (Version = {}));
// Available endpoint namespaces
var Namespace;
(function (Namespace) {
  Namespace["accounts"] = "accounts";
  Namespace["accountVerification"] = "account-verification";
  Namespace["categories"] = "categories";
  Namespace["clientConfig"] = "client-config";
  Namespace["clientConfigs"] = "client-configs";
  Namespace["customers"] = "customers";
  Namespace["meetings"] = "meetings";
  Namespace["oAuth"] = "oauth";
  Namespace["openBanking"] = "open-banking";
  Namespace["scheduledPayment"] = "payments/scheduled";
  Namespace["screenScraping"] = "scraping";
  Namespace["singlePayment"] = "payments/budpay";
  Namespace["standingOrder"] = "payments/standing-order";
  Namespace["statementIngestion"] = "statement-ingestion";
})(Namespace || (Namespace = {}));
// Possible payment frequency types
var PaymentFrequency;
(function (PaymentFrequency) {
  PaymentFrequency["daily"] = "daily";
  PaymentFrequency["weekly"] = "weekly";
  PaymentFrequency["fortnightly"] = "fortnightly";
  PaymentFrequency["monthly"] = "monthly";
  PaymentFrequency["quarterly"] = "quarterly";
  PaymentFrequency["semiAnnually"] = "semiannually";
  PaymentFrequency["yearly"] = "yearly";
})(PaymentFrequency || (PaymentFrequency = {}));
var PaymentStatusCode;
(function (PaymentStatusCode) {
  PaymentStatusCode["created"] = "Payment Created";
  PaymentStatusCode["authUrlCreated"] = "Auth URL Created";
  PaymentStatusCode["ingestingAuth"] = "Ingesting Auth";
  PaymentStatusCode["pending"] = "Pending Completion";
  PaymentStatusCode["success"] = "Payment Order Created";
  PaymentStatusCode["error"] = "Failed";
})(PaymentStatusCode || (PaymentStatusCode = {}));
var PaymentErrorCode;
(function (PaymentErrorCode) {
  PaymentErrorCode["internal"] = "INTERNAL_ERROR";
  PaymentErrorCode["authRejected"] = "AUTH_REJECTED";
  PaymentErrorCode["insufficientFunds"] = "INSUFFICIENT_FUNDS";
  PaymentErrorCode["paymentRejected"] = "PAYMENT_REJECTED";
})(PaymentErrorCode || (PaymentErrorCode = {}));
var IngestAccountStatementErrorCode;
(function (IngestAccountStatementErrorCode) {
  IngestAccountStatementErrorCode["providerMismatch"] = "provider-mismatch";
  IngestAccountStatementErrorCode["fileTooLarge"] = "file-too-large";
  IngestAccountStatementErrorCode["parsingError"] = "parsing-error";
  IngestAccountStatementErrorCode["serviceUnavailable"] = "service-unavailable";
  IngestAccountStatementErrorCode["unknown"] = "unknown-error";
})(IngestAccountStatementErrorCode || (IngestAccountStatementErrorCode = {}));
var ProviderAuthorizationUrlErrorCode;
(function (ProviderAuthorizationUrlErrorCode) {
  ProviderAuthorizationUrlErrorCode["authDenied"] = "auth-denied";
  ProviderAuthorizationUrlErrorCode["authExpired"] = "auth-expired";
  ProviderAuthorizationUrlErrorCode["failedValidation"] = "failed-validation";
  ProviderAuthorizationUrlErrorCode["genericError"] = "generic-error";
  ProviderAuthorizationUrlErrorCode["providerFailure"] = "provider-failure";
  ProviderAuthorizationUrlErrorCode["providerTimeout"] = "provider-timeout";
  ProviderAuthorizationUrlErrorCode["taskNotFound"] = "task-not-found";
  ProviderAuthorizationUrlErrorCode["unknown"] = "unknown";
})(ProviderAuthorizationUrlErrorCode || (ProviderAuthorizationUrlErrorCode = {}));
var OpenBankingConnectStatusErrorCode;
(function (OpenBankingConnectStatusErrorCode) {
  OpenBankingConnectStatusErrorCode["authDenied"] = "auth-denied";
  OpenBankingConnectStatusErrorCode["authExpired"] = "auth-expired";
  OpenBankingConnectStatusErrorCode["failedValidation"] = "failed-validation";
  OpenBankingConnectStatusErrorCode["genericError"] = "generic-error";
  OpenBankingConnectStatusErrorCode["providerFailure"] = "provider-failure";
  OpenBankingConnectStatusErrorCode["providerTimeout"] = "provider-timeout";
  OpenBankingConnectStatusErrorCode["taskNotFound"] = "task-not-found";
  OpenBankingConnectStatusErrorCode["unknown"] = "unknown";
})(OpenBankingConnectStatusErrorCode || (OpenBankingConnectStatusErrorCode = {}));
const oneDayInMs = 1000 * 60 * 60 * 24;
var MeetingReviewStatus;
(function (MeetingReviewStatus) {
  MeetingReviewStatus["reviewed"] = "reviewed";
  MeetingReviewStatus["pending"] = "pending";
})(MeetingReviewStatus || (MeetingReviewStatus = {}));

class HttpError extends Error {
  /**
   * Create an error object with extra properties specific to HTTP requests.
   *
   * @param status - The HTTP status code of the error, from 400 to 599
   * @param message - The error message to display
   * @param init - An object with extra details to be included in the error object
   * @example
   * ```javascript
   * const error = new HttpError(
   *   500,
   *   'Internal server error',
   *   { code: 'fatal-error', payload: { stackTrace: 'foobar' } },
   * )
   * ```
   */
  constructor(status, message, init = {}) {
    super(message);
    /**
     * A unique error type code
     */
    _defineProperty(this, "code", void 0);
    /**
     * Additional details included in the error response
     */
    _defineProperty(this, "payload", void 0);
    /**
     * The HTTP status code of the error, from 400 to 599
     */
    _defineProperty(this, "status", void 0);
    this.code = init.code;
    this.payload = init.payload;
    this.status = status;
  }
}

const _excluded$1 = ["auth", "headers", "host", "method", "path", "retries", "retryCooldown", "timeout"];
/**
 * Converts authentication options to the appropriate headers.
 *
 * @param auth - The authentication options
 */
function authToHeaders(auth) {
  const {
    accessToken,
    clientId,
    clientSecret,
    customerId,
    customerSecret,
    meetingId,
    nonce,
    userId
  } = auth;
  const output = {};
  if (typeof accessToken === 'string') {
    output.Authorization = `Bearer ${accessToken}`;
  }
  if (typeof clientId === 'string') {
    if (typeof clientSecret === 'string') {
      output.Authorization = `Basic ${base64Encode(`${clientId}:${clientSecret}`)}`;
    } else {
      output['X-Client-ID'] = clientId;
    }
  }
  if (typeof customerId === 'string') {
    output['X-Customer-Id'] = customerId;
  }
  if (typeof customerSecret === 'string') {
    output['X-Customer-Secret'] = customerSecret;
  }
  if (typeof meetingId === 'string') {
    output['X-Meeting-ID'] = meetingId;
  }
  if (typeof nonce === 'string') {
    output['X-Nonce'] = nonce;
  }
  if (typeof userId === 'string') {
    output['X-User-Id'] = userId;
  }
  return output;
}
/**
 * Format a request body to a supported format.
 *
 * @param body - The request body to be formatted
 * @returns A JSON stringified object, a FormData object or undefined
 */
function formatRequestBody(body) {
  if (typeof FormData !== 'undefined' && body instanceof FormData) {
    return body;
  }
  // Handle objects as bodies
  return _JSON$stringify(body);
}
/**
 * Verifies whether or not a response contains a JSON body.
 *
 * @param res - The response object
 * @returns A boolean indicating if the response contains a JSON body
 */
function containsJsonBody(res) {
  const contentType = res.headers.get('content-type');
  return typeof contentType === 'string' && _includesInstanceProperty(contentType).call(contentType, 'application/json');
}
/**
 * Extract the headers from a response.
 *
 * @remarks Headers with no value will be treated as booleans
 * @param res - The response object
 * @returns The headers names and their respective values
 */
function getHeaders(res) {
  const headers = res.headers;
  const output = {};
  _forEachInstanceProperty(headers).call(headers, function (value, key) {
    output[key] = value;
  });
  return output;
}
/**
 * Handle the response from a API endpoint.
 *
 * @param res - The response object
 * @param data - The data returned in the body of the response
 * @returns The data from the body of the response if successful
 * @throws A HTTP error object if unsuccessful
 */
function handleResponse(res, data, timestamp) {
  const json = containsJsonBody(res);
  if (!res.ok) {
    const status = res.status;
    if (json) {
      const error = data;
      throw new HttpError(status, error.message, {
        code: typeof error.code_id === 'string' ? snakeCaseToKebabCase(error.code_id) : undefined,
        payload: error.errors
      });
    } else {
      const error = data;
      throw new HttpError(status, res.statusText, {
        payload: error.data
      });
    }
  }
  const headers = getHeaders(res);
  const body = data;
  return _objectSpread({
    data: body.data,
    headers: headers,
    requestTimestamp: timestamp,
    responseTimestamp: _Date$now()
  }, typeof body.metadata === 'object' ? {
    metadata: body.metadata
  } : {});
}
/**
 * Get the response data of a request.
 *
 * @param res - The response object
 * @returns The response from the API
 */
function getResponseData(_x) {
  return _getResponseData.apply(this, arguments);
}
/**
 * Check if a request error was due to a connection issue.
 *
 * @param err - The error object
 * @returns A boolean indicating if there was a connection error
 */
function _getResponseData() {
  _getResponseData = _asyncToGenerator(function* (res) {
    let rawResponse;
    if (res.status !== 204) {
      rawResponse = yield containsJsonBody(res) ? res.json() : res.text();
    } else {
      rawResponse = {
        data: null
      };
    }
    return typeof rawResponse === 'string' ? {
      data: rawResponse
    } : rawResponse;
  });
  return _getResponseData.apply(this, arguments);
}
function getIsConnectionError(err) {
  // @ts-expect-error Error objects don't contain the status property
  return typeof err.status === 'undefined';
}
/**
 * Check if a request error was due to a server issue on the API.
 *
 * @param err - The error object
 * @returns A boolean indicating if there was a server error on the API side
 */
function getIsServerError(err) {
  // @ts-expect-error Error objects don't contain the status property
  return typeof err.status !== 'undefined' && err.status >= 500 && err.status <= 599;
}
/**
 * Create a request using the fetch API which aborts after some time.
 *
 * @remarks The ability to actually abort the request will depend on browser support, either way an error is thrown when the request times out.
 * @param url - The request URL
 * @param options - The request options
 * @param requestTimeout - The time in milliseconds to wait before aborting the request
 * @returns The request response
 */
function fetchWithTimeout(_x2, _x3, _x4) {
  return _fetchWithTimeout.apply(this, arguments);
}
/**
 * Generic API request handler using the fetch API.
 *
 * @remarks Depending on the API version being used, there will be different return values
 * @param version - The version of the API to use
 * @param namespace - The namespace of the API endpoint being used
 * @param options - Options to be passed to the fetch call
 * @returns The data from the body of the response if successful
 * @throws A HTTP error object if unsuccessful
 */
function _fetchWithTimeout() {
  _fetchWithTimeout = _asyncToGenerator(function* (url, options, requestTimeout) {
    const timeoutController = new AbortController();
    const raceValues = [fetch(url, _objectSpread(_objectSpread({}, options), {}, {
      signal: timeoutController.signal
    }))];
    if (requestTimeout !== 0) {
      raceValues.push(new _Promise(function (resolve, reject) {
        _setTimeout(function () {
          timeoutController.abort();
          reject(new Error('The request timed out.'));
        }, requestTimeout);
      }));
    }
    return _Promise.race(raceValues);
  });
  return _fetchWithTimeout.apply(this, arguments);
}
function request(_x5, _x6) {
  return _request.apply(this, arguments);
}
function _request() {
  _request = _asyncToGenerator(function* (version, namespace, options = {}) {
    const {
        auth = {},
        headers = {},
        host = getHost(),
        method = 'GET',
        path = '/',
        retries = 3,
        retryCooldown = 5000,
        timeout: requestTimeout = 60000
      } = options,
      otherOptions = _objectWithoutProperties(options, _excluded$1);
    const now = _Date$now();
    let body = null;
    let url = joinUrlPaths(host, version, namespace, path);
    if (typeof otherOptions.body !== 'undefined') {
      if (method === 'GET') {
        url += formatUrlSearchParams(otherOptions.body);
      } else if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        body = formatUrlSearchParams(otherOptions.body).substring(1);
      } else {
        body = formatRequestBody(otherOptions.body);
      }
    }
    try {
      const res = yield fetchWithTimeout(url, _objectSpread(_objectSpread({}, otherOptions), {}, {
        body: body,
        headers: _objectSpread(_objectSpread({}, authToHeaders(typeof auth === 'function' ? yield _Promise.resolve(auth()) : auth)), headers),
        method: method
      }), requestTimeout);
      const data = yield getResponseData(res);
      return handleResponse(res, data, now);
    } catch (err) {
      // Retry failed request
      if (retries !== 0 && (getIsConnectionError(err) || getIsServerError(err))) {
        yield timeout(retryCooldown);
        return request(version, namespace, _objectSpread(_objectSpread({}, options), {}, {
          retries: retries - 1
        }));
      }
      throw err;
    }
  });
  return _request.apply(this, arguments);
}

/**
 * Get the maximum number of consecutive days of data available for an account.
 *
 * @param account - The details of a connected account
 * @returns The maximum number of consecutive days of data available for the account
 */
function getAccountMaxConsecutiveDaysOfData(account) {
  var _context;
  return _reduceInstanceProperty(_context = account.transactionWindows).call(_context, function (acc, transactionWindow) {
    const diff = transactionWindow.to.getTime() - transactionWindow.from.getTime() + oneDayInMs;
    const daysCount = Math.round(diff / oneDayInMs);
    return Math.max(acc, daysCount);
  }, 0);
}
/**
 * Check if an account has the required number of consecutive days of data.
 *
 * @param account - The details of a connected account
 * @param days - The required number of consecutive days of data
 * @returns A boolean indicating if the account has the required number of days worth of data
 */
function accountHasConsecutiveDaysOfData(account, days) {
  return getAccountMaxConsecutiveDaysOfData(account) >= days;
}
/**
 * Filter a list of connected accounts to include only accounts with the required number of consecutive days of data.
 *
 * @param accounts - The list of connected accounts
 * @param days - The required number of consecutive days of data
 * @returns A list of connected accounts that have the required number of consecutive days of data
 */
function getAccountsWithConsecutiveDaysOfData(accounts, days) {
  return _filterInstanceProperty(accounts).call(accounts, function (account) {
    return accountHasConsecutiveDaysOfData(account, days);
  });
}
/**
 * Filter a list of connected accounts to include only accounts without the required number of consecutive days of data.
 *
 * @param accounts - The list of connected accounts
 * @param days - The required number of consecutive days of data
 * @returns A list of connected accounts that do not have the required number of consecutive days of data
 */
function getAccountsWithoutConsecutiveDaysOfData(accounts, days) {
  return _filterInstanceProperty(accounts).call(accounts, function (account) {
    return !accountHasConsecutiveDaysOfData(account, days);
  });
}
/**
 * Get the overall transaction window for a list of connected accounts.
 *
 * @param accounts - A list of connected accounts
 * @returns The earliest and latest dates for which transactions are available
 */
function getOverallAccountsTransactionWindow(accounts) {
  if (accounts.length === 0) {
    return;
  }
  let from;
  let to;
  _forEachInstanceProperty(accounts).call(accounts, function (account) {
    var _context2;
    _forEachInstanceProperty(_context2 = account.transactionWindows).call(_context2, function (transactionWindow) {
      if (typeof from === 'undefined' || from > transactionWindow.from) {
        from = transactionWindow.from;
      }
      if (typeof to === 'undefined' || to < transactionWindow.to) {
        to = transactionWindow.to;
      }
    });
  });
  if (typeof from === 'undefined' || typeof to === 'undefined') {
    return;
  }
  return {
    from,
    to
  };
}
/**
 * Groups a list of accounts by a given property.
 *
 * @param accounts - A list of connected accounts
 * @param property - The account data property to group accounts by
 * @returns A list of accounts grouped by the given property
 */
function groupAccountsByProperty(accounts, property) {
  const output = {};
  _forEachInstanceProperty(accounts).call(accounts, function (account) {
    const propValue = account[property];
    const collection = output[propValue];
    if (typeof collection !== 'undefined') {
      collection.push(account);
    } else {
      output[propValue] = [account];
    }
  });
  return output;
}
/**
 * Groups a list of connected accounts by account sub-type.
 *
 * @param accounts - A list of connected accounts
 * @returns Connected accounts grouped by sub-type
 */
function groupAccountsBySubType(accounts) {
  return groupAccountsByProperty(accounts, 'subType');
}
/**
 * Groups a list of connected accounts by account provider.
 *
 * @param accounts - A list of connected accounts
 * @returns Connected accounts grouped by provider
 */
function groupAccountsByProvider(accounts) {
  return groupAccountsByProperty(accounts, 'providerId');
}
/**
 * Merges transaction windows when the gap between them is less than a given threshold.
 *
 * @param account - A connected account
 * @param thresholdInDays - The number of days to use as a threshold for merging transaction windows
 */
function mergeTransactionWindowsWithThreshold(account, thresholdInDays) {
  const {
    transactionWindows
  } = account;
  if (transactionWindows.length <= 1) {
    return account;
  }
  const thresholdInMs = thresholdInDays * oneDayInMs;
  const from = transactionWindows[0].from;
  let to = transactionWindows[0].to;
  _everyInstanceProperty(transactionWindows).call(transactionWindows, function (transactionWindow, index) {
    const next = transactionWindows[index + 1];
    if (typeof next === 'undefined') {
      return false;
    }
    if (transactionWindow.to.getTime() + thresholdInMs >= next.from.getTime()) {
      // eslint-disable-line @typescript-eslint/no-extra-parens
      to = next.to;
    } else {
      return false;
    }
    return true;
  });
  return _objectSpread(_objectSpread({}, account), {}, {
    transactionWindows: [{
      from,
      to
    }]
  });
}

/**
 * Group a list of meetings by date.
 *
 * @param meetings - A list of meetings to group
 * @param excludeDataDeleted - If set to `true`, meetings with deleted financial data will be excluded
 * @returns The meetings grouped by date
 */
function groupMeetingsByDate(meetings, excludeDataDeleted) {
  const output = {};
  _forEachInstanceProperty(meetings).call(meetings, function (meeting) {
    if (excludeDataDeleted === true && meeting.dataDeleted) {
      return;
    }
    const dateKey = toUTCDateString(meeting.date);
    const collection = output[dateKey];
    if (typeof collection !== 'undefined') {
      collection.push(meeting);
    } else {
      output[dateKey] = [meeting];
    }
  });
  return output;
}

/**
 * Formats a POST OAuth Token API response.
 *
 * @param res - The response received from the OAuth token endpoint
 * @returns The OAuth tokens
 * @public
 */
function formatPostOAuthTokenResponse(res) {
  const {
    data,
    requestTimestamp
  } = res;
  const expiresIn = data.expires_in * 1000; // The time received in in seconds and needs to be converted to milliseconds
  return {
    accessToken: data.access_token,
    expires: new Date(requestTimestamp + expiresIn),
    refreshToken: data.refresh_token,
    tokenType: data.token_type
  };
}

/**
 * Formats a provider entity received from an API endpoint.
 *
 * @param provider - The provider data received from an API endpoint.
 * @returns The formatted provider data
 */
function formatProvider(provider, type) {
  return {
    id: provider.provider,
    // @ts-expect-error Depending on the API the mobile_only flag will be provided or not
    isMobileOnly: Boolean(provider.mobile_only),
    logoUrl: provider.icon,
    name: provider.display_name,
    type: type,
    // @ts-expect-error Depending on the API the maintenance status can be provided in different ways
    underMaintenance: provider.maintenance_status === 'active' || provider.in_maintenance_mode === true
  };
}

/**
 * Formats a GET Providers API response.
 *
 * @param res - The response received from the providers URL endpoint
 * @returns A map of provider IDs and provider data pairs
 * @public
 */
function formatGetAccountProvidersResponse(res, type) {
  const providers = res.data;
  const output = {};
  _forEachInstanceProperty(providers).call(providers, function (item) {
    const provider = formatProvider(item, type);
    output[provider.id] = provider;
  });
  return output;
}

const nonDigitRegEx = /[^0-9]|(?:.+(?=\*))/g;
/**
 * Normalizes an account number to the given length.
 *
 * @param accountNumber - An account number to be normalized
 * @param length - The target length of the normalized account number
 * @returns A normalized account number
 */
function normalizeAccountNumber(accountNumber, length) {
  var _context;
  return _padStartInstanceProperty(_context = accountNumber.replace(nonDigitRegEx, '')).call(_context, length, '*');
}
/**
 * Get the name of the account if available.
 *
 * @param account - The account data from the API response
 * @returns The normalized account name if available
 */
function getAccountName(account) {
  var _context2, _account$nickname;
  const nickname = _trimInstanceProperty(_context2 = (_account$nickname = account.nickname) !== null && _account$nickname !== void 0 ? _account$nickname : '').call(_context2);
  return nickname !== '' ? nickname : undefined;
}
/**
 * Get the account holder name if available.
 *
 * @param account - The account data from the API response
 * @returns The normalized account holder name if available
 */
function getAccountHolderName(account) {
  var _context3, _account$holder_name;
  const holderName = _trimInstanceProperty(_context3 = (_account$holder_name = account.holder_name) !== null && _account$holder_name !== void 0 ? _account$holder_name : '').call(_context3);
  return holderName !== '' ? holderName : undefined;
}
/**
 * Get the normalized available identifiers of an account.
 *
 * @param account - The account data from the API response
 * @returns The normalized account identifiers
 */
function getAccountIdentifiers(account) {
  var _context4;
  const output = {};
  _forEachInstanceProperty(_context4 = account.identifiers).call(_context4, function (identifier) {
    const {
      type,
      value
    } = identifier;
    if (type === 'uk_sort_code') {
      output.sortCode = formatSortCode(value);
    } else if (type === 'uk_account_number') {
      output.accountNumber = normalizeAccountNumber(value.length === 7 ? `0${value}` : value, 8); // UK account numbers have 7 or 8 digits and can be prefixed with 0 to be 16 digits
    } else if (type === 'nz_account_number') {
      output.accountNumber = normalizeAccountNumber(value.length === 15 ? `${value.substring(0, 13)}0${value.substring(13, 15)}` : value, 16); // NZ account numbers have 15 or 16 digits with a 2 or 3 digits suffix which can be prefixed with 0 to make it a 16 digit account number
    } else if (type === 'iban') {
      output.iban = value;
    } else if (type === 'pan') {
      output.accountNumber = value;
    }
  });
  return output;
}
/**
 * Get the balance of an account.
 *
 * @param account - The account data from the API response
 * @returns The account balance
 */
function getAccountBalance(account) {
  if (typeof account.balance === 'undefined') {
    return 0;
  }
  const {
    balance: {
      amount: {
        value
      },
      cdi,
      credit_line
    }
  } = account;
  const balance = (cdi === 'Debit' ? -1 : 1) * Math.abs(_parseFloat(value));
  const limit = _findInstanceProperty(credit_line).call(credit_line, function (creditLine) {
    return creditLine.type === 'Credit' || creditLine.type === 'Pre-Agreed';
  });
  // Some providers include the limit value in the balance value
  if ((limit === null || limit === void 0 ? void 0 : limit.included) === true) {
    return _parseFloat((balance - _parseFloat(limit.amount.value)).toFixed(2)); // Necessary to deal with a JavaScript quirk when doing math with floats
  }

  return balance;
}
/**
 * Get the account limit if available.
 *
 * @param account - The account data from the API response
 * @returns The account limit if available
 */
function getAccountLimit(account) {
  if (typeof account.balance === 'undefined') {
    return;
  }
  const {
    balance: {
      amount: {
        value
      },
      cdi,
      credit_line
    }
  } = account;
  const limit = _findInstanceProperty(credit_line).call(credit_line, function (creditLine) {
    return creditLine.type === 'Credit' || creditLine.type === 'Pre-Agreed' || creditLine.type === 'Available';
  });
  if (typeof limit === 'undefined') {
    return;
  }
  const limitValue = _parseFloat(limit.amount.value);
  if (limit.type === 'Available') {
    const absBalance = Math.abs(_parseFloat(value));
    return cdi === 'Debit' ? absBalance + limitValue : limitValue - absBalance;
  }
  return limitValue;
}
/**
 * Get the list of transaction windows.
 *
 * @param account - The account data from the API response
 * @returns The normalized transaction windows
 */
function getTransactionWindows(account) {
  var _context5;
  const output = [];
  _forEachInstanceProperty(_context5 = account.transaction_windows).call(_context5, function (transactionWindow) {
    const prevTransactionWindow = output[output.length - 1];
    const currentTransactionWindow = {
      from: parseDate(transactionWindow.from),
      to: parseDate(transactionWindow.to)
    };
    // Handle the first transaction window
    if (typeof prevTransactionWindow === 'undefined') {
      output.push(currentTransactionWindow);
      return;
    }
    const prevFrom = prevTransactionWindow.from;
    const prevTo = prevTransactionWindow.to;
    const currentFrom = currentTransactionWindow.from;
    const currentTo = currentTransactionWindow.to;
    const fromIntersection = currentFrom < prevFrom && currentTo >= prevFrom;
    const toIntersection = currentFrom <= prevTo && currentTo > prevTo;
    // Handle transaction window intersections
    if (fromIntersection || toIntersection) {
      prevTransactionWindow.from = new Date(Math.min(prevFrom.getTime(), currentFrom.getTime()));
      prevTransactionWindow.to = new Date(Math.max(prevTo.getTime(), currentTo.getTime()));
      return;
    }
    // Handle continuous transaction window
    if (toUTCDateString(addDuration(prevTo, {
      days: 1
    })) === toUTCDateString(currentFrom)) {
      prevTransactionWindow.to = currentTransactionWindow.to;
      return;
    }
    // Handle a new transaction window
    output.push(currentTransactionWindow);
  });
  return output;
}
/**
 * Get the type of an account.
 *
 * @param account - The account data from the API response
 * @returns The normalized account type
 */
function getAccountType(account) {
  const {
    type
  } = account;
  switch (type) {
    case 'Business':
      return 'business';
    case 'Personal':
      return 'personal';
    case '':
      return 'unknown';
    default:
      throw new Error(`Unsupported account type: ${type}`);
  }
}
/**
 * Get the sub type of an account.
 *
 * @param account - The account data from the API response
 * @returns The normalized account sub-type
 */
function getAccountSubType(account) {
  const {
    subtype
  } = account;
  switch (subtype) {
    case 'ChargeCard':
      return 'charge-card';
    case 'CreditCard':
      return 'credit-card';
    case 'CurrentAccount':
      return 'current';
    case 'EMoney':
      return 'e-money';
    case 'Loan':
      return 'loan';
    case 'Mortgage':
      return 'mortgage';
    case 'PrepaidCard':
      return 'prepaid-card';
    case 'Savings':
      return 'savings';
    case '':
      return 'unknown';
    default:
      throw new Error(`Unsupported account sub type: ${subtype}`);
  }
}
/**
 * Formats account data from an API response.
 *
 * @param account - A single account from an API response
 * @returns Formatted account data
 * @public
 */
function formatAccount(account) {
  return {
    balance: getAccountBalance(account),
    currency: account.currency,
    holderName: getAccountHolderName(account),
    id: account.account_id,
    identifiers: getAccountIdentifiers(account),
    limit: getAccountLimit(account),
    name: getAccountName(account),
    providerId: account.provider,
    subType: getAccountSubType(account),
    transactionWindows: getTransactionWindows(account),
    type: getAccountType(account)
  };
}
/**
 * Formats a GET Accounts API response.
 *
 * @param res - The response received from the accounts URL endpoint
 * @returns A list of connected accounts
 * @public
 */
function formatGetAccountsResponse(res) {
  const accounts = res.data;
  return _mapInstanceProperty(accounts).call(accounts, formatAccount);
}

/**
 * Sort transaction categories by their order number.
 *
 * @param a - A transaction category to sort
 * @param b - A transaction category to sort
 * @returns A number indicating how the elements should move in the array
 */
function sortCategories(a, b) {
  return a.order - b.order;
}
/**
 * Format a single L2 category from an API response.
 *
 * @param category - A single L2 category from an API response
 * @returns A formatted L2 category
 * @public
 */
function formatL2TransactionCategory(category) {
  return {
    id: snakeCaseToKebabCase(category.slug),
    name: category.display_name
  };
}
/**
 * Format a single L1 category from an API response.
 *
 * @param category - A single L1 category from an API response
 * @returns A formatted L1 category
 * @public
 */
function formatL1TransactionCategory(category) {
  const {
    include_in: {
      income,
      essential_expenditure,
      expenditure,
      transaction_summary,
      other_credit_summary
    } = {}
  } = category;
  const l2Categories = [...category.children];
  _sortInstanceProperty(l2Categories).call(l2Categories, sortCategories);
  return {
    children: _mapInstanceProperty(l2Categories).call(l2Categories, formatL2TransactionCategory),
    icon: snakeCaseToKebabCase(category.icon_type),
    id: snakeCaseToKebabCase(category.slug),
    isEssentialExpenseCategory: Boolean(essential_expenditure),
    isExpenseCategory: Boolean(expenditure),
    isIncomeCategory: Boolean(income),
    isMainCategory: Boolean(transaction_summary),
    isOtherCreditCategory: Boolean(other_credit_summary),
    name: category.display_name
  };
}
/**
 * Formats a GET Categories API response.
 *
 * @param res - The response received from the categories endpoint
 * @returns The list of available categories
 * @public
 */
function formatGetTransactionCategoriesResponse(res) {
  const l1Categories = [...res.data];
  _sortInstanceProperty(l1Categories).call(l1Categories, sortCategories);
  return _mapInstanceProperty(l1Categories).call(l1Categories, formatL1TransactionCategory);
}

/**
 * Formats the transaction totals of a single group from an API response.
 *
 * @remarks Amounts in currencies other than the specified one will be ignored.
 * @param group - The transaction totals data for a single group
 * @param currency - The target currency in which totals are to be displayed
 * @returns - The formatted transaction totals for the given group
 */
function formatTransactionTotalsGroup$1(group, currency) {
  var _incoming$amounts$cur, _incoming$amounts, _outgoing$amounts$cur, _outgoing$amounts, _incoming$monthly_ave, _incoming$monthly_ave2, _outgoing$monthly_ave, _outgoing$monthly_ave2, _incoming$monthly_var, _incoming$monthly_var2, _outgoing$monthly_var, _outgoing$monthly_var2;
  const {
    incoming,
    outgoing,
    subtotals
  } = group;
  const incomingAmount = Math.abs(_parseFloat((_incoming$amounts$cur = (_incoming$amounts = incoming.amounts) === null || _incoming$amounts === void 0 ? void 0 : _incoming$amounts[currency]) !== null && _incoming$amounts$cur !== void 0 ? _incoming$amounts$cur : '0'));
  const outgoingAmount = Math.abs(_parseFloat((_outgoing$amounts$cur = (_outgoing$amounts = outgoing.amounts) === null || _outgoing$amounts === void 0 ? void 0 : _outgoing$amounts[currency]) !== null && _outgoing$amounts$cur !== void 0 ? _outgoing$amounts$cur : '0'));
  const incomingCount = incoming.transaction_count;
  const outgoingCount = outgoing.transaction_count;
  const incomingMonthlyAvg = Math.abs(_parseFloat((_incoming$monthly_ave = (_incoming$monthly_ave2 = incoming.monthly_average) === null || _incoming$monthly_ave2 === void 0 ? void 0 : _incoming$monthly_ave2[currency]) !== null && _incoming$monthly_ave !== void 0 ? _incoming$monthly_ave : '0'));
  const outgoingMonthlyAvg = Math.abs(_parseFloat((_outgoing$monthly_ave = (_outgoing$monthly_ave2 = outgoing.monthly_average) === null || _outgoing$monthly_ave2 === void 0 ? void 0 : _outgoing$monthly_ave2[currency]) !== null && _outgoing$monthly_ave !== void 0 ? _outgoing$monthly_ave : '0'));
  const incomingMonthlyVariance = _parseFloat((_incoming$monthly_var = (_incoming$monthly_var2 = incoming.monthly_variance) === null || _incoming$monthly_var2 === void 0 ? void 0 : _incoming$monthly_var2[currency]) !== null && _incoming$monthly_var !== void 0 ? _incoming$monthly_var : '0');
  const outgoingMonthlyVariance = _parseFloat((_outgoing$monthly_var = (_outgoing$monthly_var2 = outgoing.monthly_variance) === null || _outgoing$monthly_var2 === void 0 ? void 0 : _outgoing$monthly_var2[currency]) !== null && _outgoing$monthly_var !== void 0 ? _outgoing$monthly_var : '0');
  const groupSubTotals = {};
  if (subtotals) {
    var _context;
    _forEachInstanceProperty(_context = _Object$keys(subtotals)).call(_context, function (subGroupKey) {
      groupSubTotals[snakeCaseToKebabCase(subGroupKey)] = formatTransactionTotalsGroup$1(subtotals[subGroupKey], currency);
    });
  }
  return {
    amount: incomingAmount - outgoingAmount,
    count: incomingCount + outgoingCount,
    currency: currency,
    incoming: {
      amount: incomingAmount,
      count: incomingCount,
      monthlyAverage: incomingMonthlyAvg,
      monthlyVariance: incomingMonthlyVariance
    },
    monthlyAverage: incomingMonthlyAvg - outgoingMonthlyAvg,
    outgoing: {
      amount: outgoingAmount,
      count: outgoingCount,
      monthlyAverage: outgoingMonthlyAvg,
      monthlyVariance: outgoingMonthlyVariance
    },
    subTotals: groupSubTotals
  };
}
/**
 * Formats transaction totals data from an API response.
 *
 * @remarks Amounts in currencies other than the specified one will be ignored.
 * @param totals - The transaction totals data
 * @param currency - The target currency in which totals are to be displayed
 * @returns The formatted transaction totals
 */
function formatTransactionTotals$1(totals, currency) {
  var _context2;
  const output = {
    amount: 0,
    count: 0,
    currency: currency,
    incoming: {
      amount: 0,
      count: 0,
      monthlyAverage: 0,
      monthlyVariance: 0
    },
    monthlyAverage: 0,
    outgoing: {
      amount: 0,
      count: 0,
      monthlyAverage: 0,
      monthlyVariance: 0
    },
    subTotals: {}
  };
  if (!totals) {
    return output;
  }
  _forEachInstanceProperty(_context2 = _Object$keys(totals)).call(_context2, function (groupKey) {
    const group = formatTransactionTotalsGroup$1(totals[groupKey], currency);
    output.amount += group.amount;
    output.incoming.amount += group.incoming.amount;
    output.outgoing.amount += group.outgoing.amount;
    output.monthlyAverage += group.monthlyAverage;
    output.incoming.monthlyAverage += group.incoming.monthlyAverage;
    output.outgoing.monthlyAverage += group.outgoing.monthlyAverage;
    output.incoming.monthlyVariance += group.incoming.monthlyVariance;
    output.outgoing.monthlyVariance += group.outgoing.monthlyVariance;
    output.count += group.count;
    output.incoming.count += group.incoming.count;
    output.outgoing.count += group.outgoing.count;
    output.subTotals[snakeCaseToKebabCase(groupKey)] = group;
  });
  return output;
}
/**
 * Formats a GET transaction totals API response.
 *
 * @remarks Amounts in currencies other than the specified one will be ignored.
 * @param res - The response received from the transaction totals endpoint
 * @returns The formatted transaction totals
 * @public
 */
function formatGetTransactionTotalsResponse(res, currency) {
  return formatTransactionTotals$1(res.data, currency);
}

/**
 * Normalize a task status code into a commonly used format.
 *
 * @param status - A status as provided by the API
 * @returns One of three possible statuses
 */
function normalizeStatus$2(status) {
  switch (status) {
    case 'Pending':
      return 'processing';
    case 'Completed':
      return 'success';
    default:
      return 'error';
  }
}
/**
 * Normalize a result into an usable error code.
 *
 * @param result - The result as provided by the API
 * @returns The error code
 */
function normalizeErrorCode$2(result) {
  switch (result) {
    case 'auth_denied':
      return ProviderAuthorizationUrlErrorCode.authDenied;
    case 'auth_expired':
      return ProviderAuthorizationUrlErrorCode.authExpired;
    case 'provider_failure':
      return ProviderAuthorizationUrlErrorCode.providerFailure;
    case 'provider_timeout':
      return ProviderAuthorizationUrlErrorCode.providerTimeout;
    case 'task_not_found':
      return ProviderAuthorizationUrlErrorCode.taskNotFound;
    case 'failed_validation':
      return ProviderAuthorizationUrlErrorCode.failedValidation;
    case 'provider_request_limit':
    case 'internal_error':
    case 'internal_transient_error':
      return ProviderAuthorizationUrlErrorCode.genericError;
    default:
      return ProviderAuthorizationUrlErrorCode.unknown;
  }
}
/**
 * Formats a GET Provider Authorization URL task status API response.
 *
 * @param res - The response received from the authorization URL task status endpoint
 * @returns The current status of the authorization URL task
 * @public
 */
function formatGetProviderAuthorizationUrlStatusResponse(res) {
  // @ts-expect-error The `url`and `result` property are only available in success and failed statuses
  const {
    provider,
    result,
    status,
    url
  } = res.data;
  const normalizedStatus = normalizeStatus$2(status);
  if (normalizedStatus === 'processing') {
    return {
      providerId: provider,
      status: normalizedStatus
    };
  }
  if (normalizedStatus === 'error') {
    return {
      errorCode: normalizeErrorCode$2(result),
      message: 'Unable to complete',
      providerId: provider,
      status: normalizedStatus
    };
  }
  return {
    providerId: provider,
    status: normalizedStatus,
    url: url
  };
}

/**
 * Normalize a task status code into a commonly used format.
 *
 * @param status - A status as provided by the API
 * @returns One of three possible statuses
 */
function normalizeStatus$1(status) {
  switch (status) {
    case 'Pending':
      return 'processing';
    case 'Completed':
      return 'success';
    default:
      return 'error';
  }
}
/**
 * Normalize a result into an usable error code.
 *
 * @param result - The result as provided by the API
 * @returns The error code
 */
function normalizeErrorCode$1(result) {
  switch (result) {
    case 'auth_denied':
      return OpenBankingConnectStatusErrorCode.authDenied;
    case 'auth_expired':
      return OpenBankingConnectStatusErrorCode.authExpired;
    case 'provider_failure':
      return OpenBankingConnectStatusErrorCode.providerFailure;
    case 'provider_timeout':
      return OpenBankingConnectStatusErrorCode.providerTimeout;
    case 'task_not_found':
      return OpenBankingConnectStatusErrorCode.taskNotFound;
    case 'failed_validation':
      return OpenBankingConnectStatusErrorCode.failedValidation;
    case 'provider_request_limit':
    case 'internal_error':
    case 'internal_timeout':
    case 'internal_transient_error':
      return OpenBankingConnectStatusErrorCode.genericError;
    default:
      return OpenBankingConnectStatusErrorCode.unknown;
  }
}
/**
 * Formats a GET open banking connect status API response
 *
 * @param response - The API response
 * @returns The current status of the open banking connect task
 */
function formatGetOpenBankingConnectStatusResponse(response) {
  const {
    data: {
      provider,
      result,
      status,
      step,
      text
    }
  } = response;
  const normalizedStatus = normalizeStatus$1(status);
  if (normalizedStatus === 'error') {
    return {
      errorCode: normalizeErrorCode$1(result),
      message: 'Unable to complete',
      provider: provider,
      status: normalizedStatus
    };
  }
  return {
    message: text,
    provider: provider,
    status: normalizedStatus,
    step: step
  };
}

/**
 * Formats a providers required fields.
 *
 * @param res - The response received from the provider required fields endpoint
 * @returns The list of required fields
 * @public
 */
function formatGetProviderRequiredFieldsResponse(res) {
  const requiredFields = res.data.required_fields;
  return _mapInstanceProperty(requiredFields).call(requiredFields, function (field) {
    return {
      name: field.field,
      regex: field.regex
    };
  });
}

/**
 * Formats a POST Ingest Account Statement API response.
 *
 * @param res - The response received from the ingest statement endpoint
 * @returns The unique ID of the statement ingestion task
 * @public
 */
function formatPostIngestAccountStatementResponse(res) {
  return res.data.task_id;
}

/**
 * Normalize a task status code into a commonly used format.
 *
 * @param status - A status as provided by the API
 * @returns One of three possible statuses
 */
function normalizeStatus(status) {
  switch (status) {
    case 'Pending':
      return 'processing';
    case 'Success':
      return 'success';
    default:
      return 'error';
  }
}
/**
 * Normalize a task error code into a commonly used format.
 *
 * @param code - An error code as provided by the API
 * @returns One of four possible error codes
 */
function normalizeErrorCode(code) {
  switch (code) {
    case 'service_unavailable':
      return IngestAccountStatementErrorCode.serviceUnavailable;
    case 'statement_too_big_error':
      return IngestAccountStatementErrorCode.fileTooLarge;
    case 'provider_error':
      return IngestAccountStatementErrorCode.providerMismatch;
    case 'try_different_file_error':
      return IngestAccountStatementErrorCode.parsingError;
    default:
      return IngestAccountStatementErrorCode.unknown;
  }
}
/**
 * Formats a GET Ingest Account Statement task status API response.
 *
 * @param res - The response received from the ingest account statement task status endpoint
 * @returns The current status of the ingestion task
 * @public
 */
function formatGetIngestAccountStatementStatusResponse(res) {
  // @ts-expect-error The `error_code` property is only available in error statuses
  const {
    error_code,
    provider,
    status,
    text
  } = res.data;
  const normalizedStatus = normalizeStatus(status);
  if (normalizedStatus === 'error') {
    return {
      errorCode: normalizeErrorCode(error_code),
      message: text,
      providerId: provider,
      status: normalizedStatus
    };
  }
  return {
    message: text,
    providerId: provider,
    status: normalizedStatus
  };
}

/**
 * Formats a GET Ingested Statements API response.
 *
 * @param res - The response received from the ingested statements endpoint
 * @returns A list of ingested account statements
 * @public
 */
function formatGetIngestedAccountStatementsResponse(res) {
  const statements = res.data;
  if (!_Array$isArray(statements)) {
    return [];
  }
  return _mapInstanceProperty(statements).call(statements, function (statement) {
    return {
      fileName: statement.file_name,
      providerId: statement.provider
    };
  });
}

/**
 * Normalize a theme string to lower case
 *
 * @param theme - A theme value as provided by the API
 * @returns A string that is lower case
 */
function normalizeTheme$3(theme) {
  if (typeof theme === 'string' && theme !== '') {
    return theme.toLowerCase();
  }
}
/**
 * Formats a GET Single Payment Details API response.
 *
 * @param res - The response received from the payment details endpoint
 * @returns The details of the payment
 * @public
 */
function formatGetSinglePaymentDetailsResponse(res) {
  const {
    merchant,
    provider,
    payment,
    sender_name
  } = res.data;
  const {
    payment_id,
    amount,
    reference
  } = payment;
  return {
    amount: _parseFloat(amount.value),
    callbackUrl: merchant.redirect_url,
    currency: amount.currency,
    id: payment_id,
    merchant: {
      logoUrl: merchant.icon_url,
      name: merchant.name
    },
    provider: provider,
    reference: reference,
    sender: {
      name: sender_name
    },
    theme: normalizeTheme$3(merchant.theme_name)
  };
}

/**
 * Normalize a theme string to lower case
 *
 * @param theme - A theme value as provided by the API
 * @returns A string that is lower case
 */
function normalizeTheme$2(theme) {
  if (typeof theme === 'string' && theme !== '') {
    return theme.toLowerCase();
  }
}
/**
 * Formats a GET Scheduled Payment Details API response.
 *
 * @param res - The response received from the payment details endpoint
 * @returns The details of the payment
 * @public
 */
function formatGetScheduledPaymentDetailsResponse(res) {
  const {
    merchant,
    provider,
    scheduled_payment
  } = res.data;
  const {
    execution_date,
    amount
  } = scheduled_payment;
  return {
    amount: _parseFloat(amount.value),
    callbackUrl: merchant.redirect_url,
    currency: amount.currency,
    executionDate: typeof execution_date === 'string' ? parseDate(execution_date) : undefined,
    id: scheduled_payment.payment_id,
    merchant: {
      logoUrl: merchant.icon_url,
      name: merchant.name
    },
    provider: provider,
    reference: scheduled_payment.reference,
    theme: normalizeTheme$2(merchant.theme_name)
  };
}

/**
 * Normalize a theme string to lower case
 *
 * @param theme - A theme value as provided by the API
 * @returns A string that is lower case
 */
function normalizeTheme$1(theme) {
  if (typeof theme === 'string' && theme !== '') {
    return theme.toLowerCase();
  }
}
/**
 * Formats a GET Standing Order Details API response.
 *
 * @param res - The response received from the payment details endpoint
 * @returns The details of the payment
 * @public
 */
function formatGetStandingOrderDetailsResponse(res) {
  const {
    merchant,
    provider,
    standing_order: standingOrder
  } = res.data;
  const {
    end_date: endDate,
    recurring_amount: amount,
    start_date: startDate
  } = standingOrder;
  return {
    amount: _parseFloat(amount.value),
    callbackUrl: merchant.redirect_url,
    currency: amount.currency,
    endDate: typeof endDate === 'string' ? parseDate(endDate) : undefined,
    frequency: standingOrder.frequency,
    id: standingOrder.payment_id,
    merchant: {
      logoUrl: merchant.icon_url,
      name: merchant.name
    },
    provider: provider,
    reference: standingOrder.reference,
    startDate: typeof startDate === 'string' ? parseDate(startDate) : undefined,
    theme: normalizeTheme$1(merchant.theme_name)
  };
}

/**
 * Formats a GET Payment Providers API response.
 *
 * @param res - The response received from the providers URL endpoint
 * @returns A map of provider IDs and provider data pairs
 * @public
 */
function formatGetPaymentProvidersResponse(res) {
  const providers = res.data.providers;
  const output = {};
  _forEachInstanceProperty(providers).call(providers, function (item) {
    const provider = formatProvider(item);
    output[provider.id] = provider;
  });
  return output;
}

/**
 * Formats a GET Payment Authorization URL API response.
 *
 * @param res - The response received from the payment authorization URL endpoint
 * @returns The payment authorization URL
 * @public
 */
function formatGetPaymentAuthorizationUrlResponse(res) {
  return res.data.authorisation_url;
}

/**
 * Formats a GET Payment Status API response.
 *
 * @param res - The response received from the payment status endpoint
 * @returns The current status of the payment
 * @public
 */
function formatGetPaymentStatusResponse(res) {
  const {
    data
  } = res;
  if (data.status === PaymentStatusCode.error) {
    return {
      errorCode: data.error_code,
      status: data.status
    };
  }
  return {
    extraCharges: _parseFloat(data.extra_charges),
    status: data.status
  };
}

function normalizeValue$1(value) {
  return typeof value === 'string' && value !== '' ? value : undefined;
}
/**
 * Normalize an Agent Flow initial view string to kebab case
 *
 * @param initialView - An initial view value as provided by the API
 * @returns One of two possible values
 */
function normalizeInitialView(initialView) {
  switch (initialView) {
    case 'accounts_summary':
      return 'accounts-summary';
    case 'download_data':
      return 'download-data';
    case 'revoke_consent':
      return 'revoke-consent';
    case 'reconfirm_consent':
      return 'reconfirm-consent';
    default:
      return 'connect-accounts';
  }
}
/**
 * Normalize an Agent Flow theme string to lower case
 *
 * @param theme - A theme value as provided by the API
 * @returns A string that is lower case
 */
function normalizeTheme(theme) {
  if (typeof theme === 'string' && theme !== '') {
    return theme.toLowerCase();
  }
}
/**
 * Normalize an Agent Flow user flow string to kebab case
 *
 * @param userFlow - A user flow value as provided by the API
 * @returns One of two possible user flow values
 */
function normalizeUserFlow(userFlow) {
  switch (userFlow) {
    case 'account_verification':
      return 'account-verification';
    default:
      return 'open-banking';
  }
}
/**
 * Normalize the open banking scopes
 *
 * @param scopes - A list of scopes as provided by the API
 * @returns An object defining if each scope is included in the list
 */
function normalizeOpenBankingScopes(scopes = []) {
  return {
    accounts: _includesInstanceProperty(scopes).call(scopes, 'accounts'),
    balances: _includesInstanceProperty(scopes).call(scopes, 'balances'),
    directDebits: _includesInstanceProperty(scopes).call(scopes, 'direct-debits'),
    parties: _includesInstanceProperty(scopes).call(scopes, 'parties'),
    transactions: _includesInstanceProperty(scopes).call(scopes, 'transactions')
  };
}
/**
 * Normalize the experiments
 *
 * @param experiments - An object containing the experiments configuration
 * @returns An object containing the normalized experiments configuration
 */
function normalizeExperiments(experiments) {
  var _context;
  const normalizedExperiments = {};
  _forEachInstanceProperty(_context = _Object$keys(experiments)).call(_context, key => {
    const camelCaseKey = snakeCaseToCamelCase(key);
    const kebabCaseValue = snakeCaseToKebabCase(experiments[key]);
    normalizedExperiments[camelCaseKey] = kebabCaseValue;
  });
  return normalizedExperiments;
}
function normalizeFinancialDataTypes(financialDataTypes) {
  if (typeof financialDataTypes === 'undefined') {
    return [];
  }
  return financialDataTypes;
}
/**
 * Define if a client uses the Assess products
 *
 * @param scopes - A comma separated list of client scopes
 * @returns A boolean indicating if the client uses assess products
 */
function getIsAssessClient(scopes) {
  const scopesList = scopes.split(',');
  return _includesInstanceProperty(scopesList).call(scopesList, 'assess_uk');
}
/**
 * Normalize the agent object
 *
 * @param agent - The agent object as provided by the API
 * @returns A normalized agent object
 */
function normalizeAgent(agent) {
  if (agent !== null) {
    return {
      id: agent.id,
      logoUrl: agent.logo_url,
      name: agent.name
    };
  }
}
/**
 * Formats a GET Agent Flow client configuration API response.
 *
 * @param res - The response received from the client config endpoint
 * @returns The configuration for an Agent Flow connection
 * @public
 */
function formatGetAgentFlowConfigResponse(res) {
  var _normalizeValue;
  const {
    data
  } = res;
  const initialView = normalizeInitialView(data.initial_screen);
  const enableAccountsSummary = Boolean(data.accounts_summary) || Boolean(data.reconfirm_consent) || Boolean(initialView !== 'connect-accounts');
  return {
    agent: normalizeAgent(data.agent),
    app: {
      logoUrl: normalizeValue$1(data.logo_url),
      name: data.company_name
    },
    callbackUrl: data.callback_url,
    clientRegulatorCompanyRefNumber: normalizeValue$1(data.license_number),
    dataLifespan: normalizeValue$1(data.transaction_duration),
    enableAccountsSummary: enableAccountsSummary,
    enableAsyncConnect: Boolean(data.enable_async_connect),
    endUserAgreementUrl: normalizeValue$1(data.disclaimer_url),
    experiments: normalizeExperiments(data.experiments),
    financialDataTypes: normalizeFinancialDataTypes(data.resources),
    initialView: initialView,
    isAssessClient: getIsAssessClient(data.scopes),
    multiConnect: Boolean(data.connect_more_accounts_button),
    openBankingScopes: normalizeOpenBankingScopes(data.consent_endpoints),
    provider: normalizeValue$1(data.provider),
    providerTypes: (_normalizeValue = normalizeValue$1(data.provider_types)) === null || _normalizeValue === void 0 ? void 0 : _normalizeValue.split(','),
    providerWhitelist: data.providers,
    reconfirmConsent: Boolean(data.reconfirm_consent),
    reconfirmConsentRedirect: Boolean(data.reconfirm_consent_redirect),
    recurringDataAccess: Boolean(data.repetitive_access),
    skipSuccessScreen: Boolean(data.skip_success_screen),
    theme: normalizeTheme(data.theme),
    userFlow: normalizeUserFlow(data.flow)
  };
}

/**
 * Formats a POST Agent Flow OAuth Token API response.
 *
 * @param res - The response received from the Agent Flow OAuth token endpoint
 * @returns The OAuth tokens
 * @public
 */
function formatAgentFlowOAuthTokenResponse(res) {
  const {
    data,
    requestTimestamp
  } = res;
  const expiresIn = data.expires_in * 1000; // The time received in in seconds and needs to be converted to milliseconds
  return {
    accessToken: data.access_token,
    expires: new Date(requestTimestamp + expiresIn),
    redirectUrl: data.redirect_url,
    refreshToken: data.refresh_token,
    tokenType: data.token_type
  };
}

/**
 * Formats a GET Affordability Dashboard configuration API response.
 *
 * @param res - The response received from the client config endpoint
 * @returns The configuration for an Affordability Dashboard client
 * @public
 */
function formatGetAffordabilityDashboardConfig(res) {
  var _data$additional_conf;
  const {
    data
  } = res;
  return {
    config: (_data$additional_conf = data.additional_configuration) !== null && _data$additional_conf !== void 0 ? _data$additional_conf : {},
    id: data.client_id,
    name: data.name,
    organisationId: data.organisation_id
  };
}
/**
 * Formats a GET Affordability Dashboard configuration list API response.
 *
 * @param res - The response received from the client config list endpoint
 * @returns The list of configurations for Affordability Dashboard clients
 * @public
 */
function formatGetAffordabilityDashboardConfigList(res) {
  const {
    data
  } = res;
  return _mapInstanceProperty(data).call(data, function (config) {
    return {
      id: config.client_id,
      name: config.name,
      organisationId: config.organisation_id
    };
  });
}

/**
 * Format the frequency of a transaction.
 *
 * @param frequencies - The transaction frequency value
 * @returns A formatted list of transaction frequencies or `undefined`
 */
function formatTransactionFrequency(frequencies) {
  const normalizedFrequencies = typeof frequencies === 'string' ? [frequencies] : frequencies;
  if (!_Array$isArray(normalizedFrequencies)) {
    return;
  }
  const output = [];
  _forEachInstanceProperty(normalizedFrequencies).call(normalizedFrequencies, function (frequency) {
    switch (frequency) {
      case '12M':
        return output.push(PaymentFrequency.yearly);
      case '6M':
        return output.push(PaymentFrequency.semiAnnually);
      case 'Q':
        return output.push(PaymentFrequency.quarterly);
      case 'M':
        return output.push(PaymentFrequency.monthly);
      case '2W':
        return output.push(PaymentFrequency.fortnightly);
      case 'W':
        return output.push(PaymentFrequency.weekly);
      case '1D':
        return output.push(PaymentFrequency.daily);
    }
  });
  return output.length ? output : undefined;
}
/**
 * Formats a transaction frequency to the format used by the APIs.
 *
 * @param frequency - The frequency to be formatted
 * @returns A frequency value suitable for use with the APIs
 */
function formatApiTransactionFrequency(frequency) {
  switch (frequency) {
    case PaymentFrequency.yearly:
      return '12M';
    case PaymentFrequency.semiAnnually:
      return '6M';
    case PaymentFrequency.quarterly:
      return 'Q';
    case PaymentFrequency.monthly:
      return 'M';
    case PaymentFrequency.fortnightly:
      return '2W';
    case PaymentFrequency.weekly:
      return 'W';
    case PaymentFrequency.daily:
      return '1D';
    default:
      throw new Error(`Unsupported transaction frequency: ${frequency}`);
  }
}

/**
 * Format a single transaction from an API response.
 *
 * @param category - A single transaction from an API response
 * @returns A formatted transaction
 * @public
 */
function formatMeetingTransaction(transactionData) {
  var _attributes$client_ca, _attributes$client_ca2, _transactionData$tags;
  const {
    attributes = {},
    transaction: {
      account_id,
      amount,
      cdi,
      date,
      description,
      id
    }
  } = transactionData;
  const category = (_attributes$client_ca = attributes.client_category_l1) === null || _attributes$client_ca === void 0 ? void 0 : _attributes$client_ca[0];
  const subCategory = (_attributes$client_ca2 = attributes.client_category_l2) === null || _attributes$client_ca2 === void 0 ? void 0 : _attributes$client_ca2[0];
  const tags = (_transactionData$tags = transactionData.tags) !== null && _transactionData$tags !== void 0 ? _transactionData$tags : [];
  return {
    accountId: account_id,
    benefit: _includesInstanceProperty(tags).call(tags, 'benefit'),
    category: typeof category === 'string' ? snakeCaseToKebabCase(category) : undefined,
    currency: amount.currency,
    date: parseDate(date),
    debtCollection: _includesInstanceProperty(tags).call(tags, 'debt-collection'),
    frequency: formatTransactionFrequency(attributes['regular-payment-frequency']),
    id: id,
    internal: _includesInstanceProperty(tags).call(tags, 'internal-transfer'),
    oneOff: _includesInstanceProperty(tags).call(tags, 'one-off-transaction'),
    reference: description,
    regular: _includesInstanceProperty(tags).call(tags, 'regular-transaction'),
    salary: _includesInstanceProperty(tags).call(tags, 'salary'),
    subCategory: typeof subCategory === 'string' ? snakeCaseToKebabCase(subCategory) : undefined,
    value: Math.abs(_parseFloat(amount.value)) * (cdi === 'Credit' ? 1 : -1)
  };
}
/**
 * Formats a GET Transactions API response.
 *
 * @param res - The response received from the transactions endpoint
 * @returns The list of requested transactions
 * @public
 */
function formatGetMeetingTransactionsResponse(res) {
  var _context;
  // The API may return null
  if (!_Array$isArray(res.data)) {
    return [];
  }
  return _mapInstanceProperty(_context = res.data).call(_context, formatMeetingTransaction);
}

/**
 * Normalizes the value of a metadata field from the meeting details.
 *
 * @param value - The value to be normalized
 * @returns The normalized value
 */
function normalizeValue(value) {
  if (typeof value === 'string') {
    const normalizedStr = _trimInstanceProperty(value).call(value);
    if (normalizedStr === '') {
      return;
    }
    return normalizedStr;
  }
  return value;
}
/**
 * Normalizes the value of a review status from the meeting details.
 *
 * @param reviewStatus - The review status to be normalized
 * @returns The normalized review status
 */
function normalizeReviewStatus$1(reviewStatus) {
  if (reviewStatus === '') {
    return MeetingReviewStatus.pending;
  } else if (reviewStatus === 'reviewed') {
    return MeetingReviewStatus.reviewed;
  }
  return undefined;
}
/**
 * Format the date of a meeting.
 *
 * @param details - The meeting details as returned by an API response
 * @returns The formatted date of the meeting
 */
function formatMeetingDate(details) {
  // Handle current data format
  if (typeof details.appointment_date !== 'undefined') {
    return parseDate(details.appointment_date);
  }
  // Handle legacy data format
  return parseDate(details.customer.appointment_date);
}
/**
 * Format the details of the applicants associated with a meeting.
 *
 * @param details - The meeting details as returned by an API response
 * @returns The formatted meeting applicants details
 */
function formatApplicantsDetails(details) {
  const applicants = [];
  // Handle current data format
  if (typeof details.primary_applicant !== 'undefined') {
    var _meetingDetails$metad, _meetingDetails$secon;
    const meetingDetails = details;
    const metadata = (_meetingDetails$metad = meetingDetails.metadata) !== null && _meetingDetails$metad !== void 0 ? _meetingDetails$metad : {};
    const mainApplicantDetails = meetingDetails.primary_applicant;
    const secondaryApplicants = (_meetingDetails$secon = meetingDetails.secondary_applicants) !== null && _meetingDetails$secon !== void 0 ? _meetingDetails$secon : [];
    applicants.push({
      customerId: normalizeValue(metadata.customer_id),
      email: normalizeValue(metadata.customer_email),
      firstName: normalizeValue(mainApplicantDetails.first_name),
      lastName: normalizeValue(mainApplicantDetails.last_name)
    }, ..._mapInstanceProperty(secondaryApplicants).call(secondaryApplicants, function (applicant) {
      return {
        firstName: normalizeValue(applicant.first_name),
        lastName: normalizeValue(applicant.last_name)
      };
    }));
    // Handle legacy data format
  } else {
    var _meetingDetails$metad2;
    const meetingDetails = details;
    const metadata = (_meetingDetails$metad2 = meetingDetails.metadata) !== null && _meetingDetails$metad2 !== void 0 ? _meetingDetails$metad2 : {};
    const mainApplicantDetails = meetingDetails.customer;
    const secondaryApplicantFirstName = normalizeValue(metadata.joint_applicant_first_name);
    const secondaryApplicantLastName = normalizeValue(metadata.joint_applicant_last_name);
    applicants.push({
      customerId: normalizeValue(metadata.customer_id),
      firstName: normalizeValue(mainApplicantDetails.first_name),
      lastName: normalizeValue(mainApplicantDetails.last_name)
    });
    if (typeof secondaryApplicantFirstName === 'string' && typeof secondaryApplicantLastName === 'string') {
      applicants.push({
        firstName: secondaryApplicantFirstName,
        lastName: secondaryApplicantLastName
      });
    }
  }
  const mainApplicant = applicants[0];
  const jointApplicant = applicants[1];
  const applicationType = applicants.length === 1 ? 'single' : 'joint';
  // TODO: remove legacy properties (breaking change)
  return {
    applicants,
    applicationType,
    jointApplicant,
    mainApplicant // Kept for backwards compatibility
  };
}
/**
 * Format the details of a data broker.
 *
 * @param details - The meeting details as returned by an API response
 * @returns The formatted data broker details
 */
function formatDataBrokerDetails(details) {
  let brokerName;
  let brokerOrganization;
  // Handle current data format
  if (typeof details.primary_applicant !== 'undefined') {
    var _details$metadata;
    const metadata = (_details$metadata = details.metadata) !== null && _details$metadata !== void 0 ? _details$metadata : {};
    brokerName = normalizeValue(metadata.data_broker_name);
    brokerOrganization = normalizeValue(metadata.data_broker_organization);
    // Handle legacy data format
  } else {
    var _details$metadata2, _metadata$organizatio;
    const metadata = (_details$metadata2 = details.metadata) !== null && _details$metadata2 !== void 0 ? _details$metadata2 : {};
    brokerName = normalizeValue(metadata.verified_by);
    brokerOrganization = normalizeValue((_metadata$organizatio = metadata.organization) !== null && _metadata$organizatio !== void 0 ? _metadata$organizatio : metadata.organisation);
  }
  if (typeof brokerName === 'string' && typeof brokerOrganization === 'string') {
    return {
      name: brokerName,
      organization: brokerOrganization
    };
  }
}
/**
 * Format the details of the customer connection.
 *
 * @param details - The meeting details as returned by an API response
 * @returns The formatted customer connection details
 */
function formatCustomerConnectionDetails(details) {
  var _details$customer_lin;
  const customerConnectionDetails = (_details$customer_lin = details.customer_link) !== null && _details$customer_lin !== void 0 ? _details$customer_lin : undefined;
  if (typeof customerConnectionDetails !== 'undefined') {
    return {
      createdAt: parseDate(customerConnectionDetails.created_at),
      isCompleted: Boolean(customerConnectionDetails.finished_connecting_accounts),
      isInitiated: Boolean(customerConnectionDetails.expired),
      url: customerConnectionDetails.url
    };
  }
}
/**
 * Format the data type of the meeting details.
 *
 * @param details - The meeting details as returned by an API response
 * @returns The formatted data type
 */
function formatDataType(details) {
  var _details$metadata3;
  const metadata = (_details$metadata3 = details.metadata) !== null && _details$metadata3 !== void 0 ? _details$metadata3 : {};
  switch (metadata.data_type) {
    case 'client_form':
      return 'client-form';
    default:
      return 'default';
  }
}
/**
 * Format the meeting details provided in an API response.
 *
 * @remarks The metadata is free-form, we make some assumptions about how it's being used
 * @param details - The meeting details as returned by an API response
 * @returns The formatted meeting details
 */
function formatMeetingDetails(details) {
  var _details$metadata4;
  const metadata = (_details$metadata4 = details.metadata) !== null && _details$metadata4 !== void 0 ? _details$metadata4 : {};
  return _objectSpread({
    accountConnectionInitiator: normalizeValue(metadata.account_connection_initiator),
    advisorName: normalizeValue(metadata.advisor_name),
    applicationId: normalizeValue(metadata.application_id),
    connectedAccounts: details.accounts_connected,
    createdAt: parseDate(details.created_at),
    customerConnection: formatCustomerConnectionDetails(details),
    dataBroker: formatDataBrokerDetails(details),
    dataDeleted: Boolean(details.financial_data_deleted),
    dataType: formatDataType(details),
    date: formatMeetingDate(details),
    expiresAt: typeof details.expires_at === 'string' && details.expires_at !== '' ? parseDate(details.expires_at) : undefined,
    id: details.meeting_id,
    // @ts-expect-error - review_status is expected to be undefined on legacy responses
    reviewStatus: normalizeReviewStatus$1(details.review_status)
  }, formatApplicantsDetails(details));
}
/**
 * Formats a GET meeting details API response.
 *
 * @param res - The response received from the meeting details API endpoint
 * @returns The details of a meeting
 * @public
 */
function formatGetMeetingDetailsResponse(res) {
  return formatMeetingDetails(res.data);
}
/**
 * Formats a GET meetings list API response.
 *
 * @param res - The response received from the meeting list API endpoint
 * @returns The list of meetings
 * @public
 */
function formatGetMeetingsResponse(res) {
  var _context;
  return _mapInstanceProperty(_context = res.data).call(_context, formatMeetingDetails);
}

/**
 * Formats the account data from the API response to a standard format.
 *
 * @param account - The account data from the report API response
 * @returns The account data in a standard format
 */
function formatAccountData(account) {
  const balance = _parseFloat(account.balance.value);
  const currency = account.balance.currency;
  const creditLine = [];
  if (account.credit_limit) {
    creditLine.push({
      amount: {
        currency: currency,
        value: account.credit_limit.value
      },
      included: false,
      type: 'Credit'
    });
  }
  return formatAccount({
    account_id: account.account_id,
    balance: {
      amount: {
        currency: currency,
        value: Math.abs(balance).toFixed(2)
      },
      cdi: balance < 0 ? 'Debit' : 'Credit',
      credit_line: creditLine,
      time: account.transaction_windows[0].to
    },
    currency: currency,
    display_identifier: null,
    holder_name: '',
    identifiers: [],
    nickname: account.nickname,
    provider: account.provider,
    subtype: account.account_sub_type,
    transaction_windows: account.transaction_windows,
    type: account.account_type
  });
}
/**
 * Formats the totals for each sub-category in a meeting report.
 *
 * @param group - The totals data for a sub-category
 * @returns The formatted totals data
 */
function formatTransactionTotalsGroup(group) {
  return {
    amount: _parseFloat(group.total.value),
    currency: group.total.currency,
    frequency: formatTransactionFrequency(group.frequency),
    monthlyAverage: _parseFloat(group.monthly_average.value),
    subTotals: {}
  };
}
/**
 * Format the transaction sub-totals from the meeting report API response.
 *
 * @param totals - The totals from the meeting report API response
 * @returns The formatted transaction totals in a standard format
 */
function formatTransactionSubTotals(totals) {
  var _context;
  const output = {
    amount: 0,
    currency: '',
    monthlyAverage: 0,
    subTotals: {}
  };
  _forEachInstanceProperty(_context = _Object$keys(totals)).call(_context, function (category) {
    const normalizedCategory = snakeCaseToKebabCase(category);
    const subTotals = formatTransactionTotalsGroup(totals[category]);
    output.amount += subTotals.amount;
    output.currency = subTotals.currency;
    output.monthlyAverage += subTotals.monthlyAverage;
    output.subTotals[normalizedCategory] = subTotals;
  });
  // Fix precision issues
  output.amount = _parseFloat(output.amount.toFixed(2));
  output.monthlyAverage = _parseFloat(output.monthlyAverage.toFixed(2));
  return output;
}
/**
 * Format the transaction totals from the meeting report API response.
 *
 * @param totals - The totals from the meeting report API response
 * @returns The formatted transaction totals in a standard format
 */
function formatTransactionTotals(totals) {
  var _context2;
  const output = {
    amount: 0,
    currency: '',
    monthlyAverage: 0,
    subTotals: {}
  };
  _forEachInstanceProperty(_context2 = _Object$keys(totals)).call(_context2, function (category) {
    const normalizedCategory = snakeCaseToKebabCase(category);
    const subTotals = formatTransactionSubTotals(totals[category]);
    output.amount += subTotals.amount;
    output.currency = subTotals.currency;
    output.monthlyAverage += subTotals.monthlyAverage;
    output.subTotals[normalizedCategory] = subTotals;
  });
  // Fix precision issues
  output.amount = _parseFloat(output.amount.toFixed(2));
  output.monthlyAverage = _parseFloat(output.monthlyAverage.toFixed(2));
  return output;
}
/**
 * Formats the transaction data from the API response to a standard format.
 *
 * @param transaction - The transaction data from the report API response
 * @returns The transaction data in a standard format
 */
function formatTransaction(transaction) {
  return {
    currency: transaction.amount.currency,
    date: parseDate(transaction.date),
    frequency: formatTransactionFrequency(transaction.frequency),
    id: transaction.id,
    originalFrequency: formatTransactionFrequency(transaction.original_frequency),
    reference: transaction.description,
    value: Math.abs(_parseFloat(transaction.amount.value)) * (transaction.cdi === 'Credit' ? 1 : -1)
  };
}
/**
 * Formats the legacy expenses sub-category data from a meeting report API response.
 *
 * @param expensesSubCategory - The legacy expenses sub-category response data as returned by the API
 * @returns The formatted legacy expenses sub-category
 */
const formatLegacyExpensesSubCategory = expensesSubCategory => {
  var _expensesSubCategory$, _expensesSubCategory$2;
  const monthlyAverage = (_expensesSubCategory$ = expensesSubCategory.monthly_average) !== null && _expensesSubCategory$ !== void 0 ? _expensesSubCategory$ : {
    value: undefined
  };
  const total = (_expensesSubCategory$2 = expensesSubCategory.total) !== null && _expensesSubCategory$2 !== void 0 ? _expensesSubCategory$2 : {
    currency: undefined,
    value: undefined
  };
  return {
    currency: total.currency,
    frequency: formatTransactionFrequency(expensesSubCategory.frequency),
    key: snakeCaseToKebabCase(expensesSubCategory.key),
    monthlyAverage: typeof monthlyAverage.value === 'string' ? _parseFloat(monthlyAverage.value) : undefined,
    name: expensesSubCategory.display_name,
    total: typeof total.value === 'string' ? _parseFloat(total.value) : undefined
  };
};
/**
 * Formats the legacy expenses category data from a meeting report API response.
 *
 * @param expensesCategory - The legacy expenses category response data as returned by the API
 * @returns The formatted legacy expenses category
 */
const formatLegacyExpensesCategory = expensesCategory => {
  var _context3;
  return {
    children: _mapInstanceProperty(_context3 = expensesCategory.subsections).call(_context3, formatLegacyExpensesSubCategory),
    key: snakeCaseToKebabCase(expensesCategory.key),
    name: expensesCategory.display_name
  };
};
/**
 * Formats the legacy expenses data from a meeting report API response.
 *
 * @param expenses - The legacy expenses response data as returned by the API
 * @returns The formatted legacy expenses
 */
const formatLegacyExpenses = (expenses = {}) => {
  var _context4;
  const output = {};
  _forEachInstanceProperty(_context4 = _Object$keys(expenses)).call(_context4, key => {
    var _context5;
    const normalizedKey = snakeCaseToCamelCase(key);
    output[normalizedKey] = _mapInstanceProperty(_context5 = expenses[key]).call(_context5, formatLegacyExpensesCategory);
  }, {});
  return output;
};
/**
 * Formats the data from a meeting report API response.
 *
 * @param report - The response data as returned by the API
 * @returns The formatted meeting report
 */
function formatMeetingReport(report) {
  var _context6, _context7, _context8, _context9, _context10, _context11;
  const {
    accounts,
    averages_taken_over,
    legacy_expenses_formats,
    meeting,
    totals,
    transactions
  } = report;
  return {
    accounts: _mapInstanceProperty(accounts).call(accounts, formatAccountData),
    from: parseDate(averages_taken_over.date_from),
    legacyExpenses: formatLegacyExpenses(legacy_expenses_formats),
    meeting: formatMeetingDetails(meeting),
    to: parseDate(averages_taken_over.date_to),
    totals: {
      expenses: formatTransactionTotals(totals.expenses),
      otherIncome: formatTransactionSubTotals(totals.other_income),
      regularIncome: formatTransactionSubTotals(totals.regular_income)
    },
    transactions: {
      general: _mapInstanceProperty(_context6 = transactions.general).call(_context6, formatTransaction),
      oneOff: _mapInstanceProperty(_context7 = transactions.one_off).call(_context7, formatTransaction),
      otherIncome: _mapInstanceProperty(_context8 = transactions.other_income).call(_context8, formatTransaction),
      transfers: _mapInstanceProperty(_context9 = transactions.transfers).call(_context9, formatTransaction),
      uncategorised: _mapInstanceProperty(_context10 = transactions.uncategorised).call(_context10, formatTransaction),
      updatedFrequencies: _mapInstanceProperty(_context11 = transactions.updated_frequencies).call(_context11, formatTransaction)
    }
  };
}
/**
 * Formats a GET meeting report API response.
 *
 * @param res - The response received from the meeting report endpoint
 * @returns The formatted meeting report
 */
function formatGetMeetingReportResponse(res) {
  return formatMeetingReport(res.data);
}

/**
 * Formats a provider login form.
 *
 * @param res - The response received from the login form endpoint
 * @returns The task ID and list of fields
 * @public
 */
function formatGetProviderLoginFormResponse(res) {
  const {
    inputs,
    task_id
  } = res.data;
  return {
    fields: _mapInstanceProperty(inputs).call(inputs, function (input) {
      return {
        id: input.id,
        label: input.label,
        // @ts-expect-error The `src` property is only available for type `captcha`
        src: input.src,
        type: input.type
      };
    }),
    taskId: task_id
  };
}

/**
 * Get the list of available transaction categories.
 *
 * @param auth - The authentication details for the request
 * @param options - Additional options to handle the request
 * @returns The configuration for the current agent flow connection
 * @public
 *
 * @example
 * ```javascript
 * const result = await getTransactionCategories({
 *   clientId: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getTransactionCategories(_x) {
  return _getTransactionCategories.apply(this, arguments);
}
function _getTransactionCategories() {
  _getTransactionCategories = _asyncToGenerator(function* (auth, options = {}) {
    const {
      preferredLocale
    } = options;
    const res = yield request(Version.v2, Namespace.categories, {
      auth: auth,
      body: {
        lang: preferredLocale
      },
      method: 'GET',
      path: '/'
    });
    return formatGetTransactionCategoriesResponse(res);
  });
  return _getTransactionCategories.apply(this, arguments);
}

/**
 * Get a list of connected accounts.
 *
 * @param auth - The authentication details for the request
 * @returns A list of connected accounts
 * @public
 *
 * @example
 * ```javascript
 * const result = await getAccounts({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getAccounts(_x) {
  return _getAccounts.apply(this, arguments);
}
function _getAccounts() {
  _getAccounts = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.beta, Namespace.accounts, {
      auth: auth,
      method: 'GET',
      path: '/'
    });
    return formatGetAccountsResponse(res);
  });
  return _getAccounts.apply(this, arguments);
}

/**
 * Get a list of available open banking providers.
 *
 * @param auth - The authentication details for the request
 * @param options - Additional options to handle the request
 * @returns A map of provider IDs and provider data pairs
 * @public
 *
 * @example
 * ```javascript
 * const result = await getOpenBankingProviders({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getOpenBankingProviders(_x) {
  return _getOpenBankingProviders.apply(this, arguments);
}
function _getOpenBankingProviders() {
  _getOpenBankingProviders = _asyncToGenerator(function* (auth, options = {}) {
    const {
      region,
      types
    } = options;
    const res = yield request(Version.v1, Namespace.openBanking, {
      auth: auth,
      body: {
        region: region,
        types: _Array$isArray(types) ? types.join(',') : undefined
      },
      method: 'GET',
      path: '/providers'
    });
    return formatGetAccountProvidersResponse(res, 'open-banking');
  });
  return _getOpenBankingProviders.apply(this, arguments);
}

/**
 * Get a list of available scraping providers.
 *
 * @param auth - The authentication details for the request
 * @returns A map of provider IDs and provider data pairs
 * @public
 *
 * @example
 * ```javascript
 * const result = await getScrapingProviders({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getScrapingProviders(_x) {
  return _getScrapingProviders.apply(this, arguments);
}
function _getScrapingProviders() {
  _getScrapingProviders = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.screenScraping, {
      auth: auth,
      method: 'GET',
      path: '/providers'
    });
    return formatGetAccountProvidersResponse(res, 'scraping');
  });
  return _getScrapingProviders.apply(this, arguments);
}

/**
 * Get a list of available statement ingestion providers.
 *
 * @param auth - The authentication details for the request
 * @param options - Additional options to handle the request
 * @returns A map of provider IDs and provider data pairs
 * @public
 *
 * @example
 * ```javascript
 * const result = await getStatementIngestionProviders({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getStatementIngestionProviders(_x) {
  return _getStatementIngestionProviders.apply(this, arguments);
}
function _getStatementIngestionProviders() {
  _getStatementIngestionProviders = _asyncToGenerator(function* (auth, options = {}) {
    const {
      region,
      types
    } = options;
    const res = yield request(Version.v1, Namespace.statementIngestion, {
      auth: auth,
      body: {
        region: region,
        types: _Array$isArray(types) ? types.join(',') : undefined
      },
      method: 'GET',
      path: '/providers'
    });
    return formatGetAccountProvidersResponse(res, 'statement-ingestion');
  });
  return _getStatementIngestionProviders.apply(this, arguments);
}

const _excluded = ["openBanking", "scraping", "statementIngestion"];
/**
 * Get a list of available providers for different ingestion methods.
 *
 * @param auth - The authentication details for the request
 * @param options - Additional options to handle the request
 * @returns A map of provider IDs and provider data pairs
 * @public
 *
 * @example
 * ```javascript
 * const result = await getAccountProviders({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getAccountProviders(_x, _x2) {
  return _getAccountProviders.apply(this, arguments);
}
function _getAccountProviders() {
  _getAccountProviders = _asyncToGenerator(function* (auth, options) {
    const {
        openBanking,
        scraping,
        statementIngestion
      } = options,
      commonOptions = _objectWithoutProperties(options, _excluded);
    const result = yield _Promise.all([openBanking === true ? getOpenBankingProviders(auth, commonOptions) : _Promise.resolve({}), scraping === true ? getScrapingProviders(auth) : _Promise.resolve({}), statementIngestion === true ? getStatementIngestionProviders(auth, commonOptions) : _Promise.resolve({})]);
    return _reduceInstanceProperty(result).call(result, function (acc, providers) {
      return _objectSpread(_objectSpread({}, acc), providers);
    }, {});
  });
  return _getAccountProviders.apply(this, arguments);
}

/**
 * Create an OAuth token.
 *
 * @param auth - The authentication details for the request
 * @public
 *
 * @example
 * ```javascript
 * await createOAuthToken({
 *   nonce: '38158fa9baa47bfde34f',
 *   token: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function createOAuthToken(_x) {
  return _createOAuthToken.apply(this, arguments);
}
function _createOAuthToken() {
  _createOAuthToken = _asyncToGenerator(function* (auth) {
    const {
      clientId,
      clientSecret,
      nonce,
      token
    } = auth;
    let body = {
      grant_type: 'client_credentials'
    };
    // The endpoint has different requirements depending on the type of authentication being done
    if (typeof nonce === 'string' && typeof token === 'string') {
      body = {
        grant_type: 'authorization_code',
        nonce: nonce,
        token: token
      };
    }
    const res = yield request(Version.v1, Namespace.oAuth, {
      auth: {
        clientId,
        clientSecret
      },
      body: body,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      path: '/token'
    });
    return formatPostOAuthTokenResponse(res);
  });
  return _createOAuthToken.apply(this, arguments);
}

/**
 * Refresh an existing OAuth token.
 *
 * @param auth - The authentication details for the request
 * @public
 *
 * @example
 * ```javascript
 * await refreshOAuthToken({
 *   nonce: '38158fa9baa47bfde34f',
 *   refreshToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function refreshOAuthToken(_x) {
  return _refreshOAuthToken.apply(this, arguments);
}
function _refreshOAuthToken() {
  _refreshOAuthToken = _asyncToGenerator(function* (auth) {
    const {
      clientId,
      nonce,
      refreshToken
    } = auth;
    const res = yield request(Version.v1, Namespace.oAuth, {
      auth: {
        clientId
      },
      body: {
        grant_type: 'refresh_token',
        nonce: nonce,
        refresh_token: refreshToken
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      path: '/token'
    });
    return formatPostOAuthTokenResponse(res);
  });
  return _refreshOAuthToken.apply(this, arguments);
}

/**
 * Get the current status of an open banking provider authorization url task.
 *
 * @param auth - The authentication details for the request
 * @param taskId - The unique ID of the ingestion task
 * @returns The details of the current status of the task
 * @public
 *
 * @example
 * ```javascript
 * const result = await getOpenBankingProviderAuthorizationUrlStatus({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, '5cb43e7b-0e56-4d54-a17f-36a9c26eb60c')
 * ```
 */
function getOpenBankingProviderAuthorizationUrlStatus(_x, _x2) {
  return _getOpenBankingProviderAuthorizationUrlStatus.apply(this, arguments);
}
function _getOpenBankingProviderAuthorizationUrlStatus() {
  _getOpenBankingProviderAuthorizationUrlStatus = _asyncToGenerator(function* (auth, taskId) {
    const res = yield request(Version.v1, Namespace.openBanking, {
      auth: auth,
      method: 'GET',
      path: `/authorisation-url/${taskId}`
    });
    return formatGetProviderAuthorizationUrlStatusResponse(res);
  });
  return _getOpenBankingProviderAuthorizationUrlStatus.apply(this, arguments);
}

/**
 * Formats a POST Provider Authorization URL Task API response.
 *
 * @param res - The response received from the authorization URL task endpoint
 * @returns The unique ID of the provider authorization url task
 * @public
 */
function formatPostProviderAuthorizationUrlTaskResponse(res) {
  return res.data.task_id;
}

/**
 * Match a payment error code to a HTTP status code.
 *
 * @param errorCode - The error code to match
 * @returns A HTTP status code suited for the payment error
 */
function getPaymentErrorHttpStatusCode(errorCode) {
  switch (errorCode) {
    case PaymentErrorCode.authRejected:
      return 403;
    case PaymentErrorCode.insufficientFunds:
      return 400;
    case PaymentErrorCode.paymentRejected:
      return 402;
    default:
      return 500;
  }
}
/**
 * Match a provider authorization url error code to a HTTP status code.
 *
 * @param errorCode - The statement ingestion status error code
 * @returns A HTTP response status code
 */
function getProviderAuthorizationUrlErrorHttpStatusCode(errorCode) {
  switch (errorCode) {
    case ProviderAuthorizationUrlErrorCode.failedValidation:
      return 400;
    case ProviderAuthorizationUrlErrorCode.authExpired:
    case ProviderAuthorizationUrlErrorCode.authDenied:
      return 401;
    case ProviderAuthorizationUrlErrorCode.taskNotFound:
      return 404;
    case ProviderAuthorizationUrlErrorCode.providerTimeout:
      return 504;
    case ProviderAuthorizationUrlErrorCode.providerFailure:
      return 502;
    default:
      return 500;
  }
}

// TODO: Breakout logic into more focused functions so that it's possible to have more fine grained control of app behaviour
/**
 * Get a URL to authorize an open banking connection with the selected provider.
 *
 * @param auth - The authentication details for the request
 * @param providerId - The ID of the provider
 * @param redirectUrl - A URL to redirect to after the provider connection
 * @param financialDataTypes - The financial data types to request access to
 * @returns The provider authorization url
 * @public
 *
 * @example
 * ```javascript
 * const result = await getOpenBankingProviderAuthorizationUrl({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, 'Monzo', 'https://www.thisisbud.com', ['accounts', 'direct-debits'])
 * ```
 */
function getOpenBankingProviderAuthorizationUrl(_x, _x2, _x3, _x4) {
  return _getOpenBankingProviderAuthorizationUrl.apply(this, arguments);
}
function _getOpenBankingProviderAuthorizationUrl() {
  _getOpenBankingProviderAuthorizationUrl = _asyncToGenerator(function* (auth, providerId, redirectUrl, financialDataTypes) {
    const taskRes = yield request(Version.v1, Namespace.openBanking, {
      auth: auth,
      body: {
        provider: providerId,
        redirect_url: redirectUrl,
        resources: financialDataTypes
      },
      method: 'POST',
      path: '/authorisation-url'
    });
    const taskId = formatPostProviderAuthorizationUrlTaskResponse(taskRes);
    const pollingInterval = getPollingInterval();
    let response;
    // Poll the status until it is either `success` or `error` (not `processing`)
    while (typeof response === 'undefined' || response.status === 'processing') {
      yield timeout(pollingInterval);
      response = yield getOpenBankingProviderAuthorizationUrlStatus(auth, taskId);
    }
    if (response.status === 'error') {
      throw new HttpError(getProviderAuthorizationUrlErrorHttpStatusCode(response.errorCode), response.message, {
        code: response.errorCode
      });
    }
    return response.url;
  });
  return _getOpenBankingProviderAuthorizationUrl.apply(this, arguments);
}

/**
 * Get the status of a unique connect status task ID
 *
 * @param auth - The authentication details
 * @param connectionTaskId - The ID of the connection task
 * @returns The current status of the connection
 * @public
 *
 * @example
 * ```javascript
 * const result = await getOpenBankingConnectStatus({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, '5cb43e7b-0e56-4d54-a17f-36a9c26eb60c')
 * ```
 */
function getOpenBankingConnectStatus(_x, _x2) {
  return _getOpenBankingConnectStatus.apply(this, arguments);
}
function _getOpenBankingConnectStatus() {
  _getOpenBankingConnectStatus = _asyncToGenerator(function* (auth, connectionTaskId) {
    const res = yield request(Version.v1, Namespace.openBanking, {
      auth: auth,
      method: 'GET',
      path: `/connect/${connectionTaskId}`
    });
    return formatGetOpenBankingConnectStatusResponse(res);
  });
  return _getOpenBankingConnectStatus.apply(this, arguments);
}

/**
 * Match a connect status error code to a HTTP status code.
 *
 * @param errorCode - The connect status error code
 * @returns A HTTP response status code
 */
function getErrorHttpStatusCode$1(errorCode) {
  switch (errorCode) {
    case OpenBankingConnectStatusErrorCode.failedValidation:
      return 400;
    case OpenBankingConnectStatusErrorCode.authExpired:
    case OpenBankingConnectStatusErrorCode.authDenied:
      return 401;
    case OpenBankingConnectStatusErrorCode.taskNotFound:
      return 404;
    case OpenBankingConnectStatusErrorCode.providerTimeout:
      return 504;
    case OpenBankingConnectStatusErrorCode.providerFailure:
      return 502;
    default:
      return 500;
  }
}
/**
 * Confirm an open banking connection
 *
 * @param auth - The authentication details
 * @param connectionTaskId - The ID of the connection task
 * @returns The provider which has been connected
 * @public
 *
 * @example
 * ```javascript
 * await comfirmOpenBankingConnection({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, '5cb43e7b-0e56-4d54-a17f-36a9c26eb60c')
 * ```
 */
function confirmOpenBankingConnection(_x, _x2) {
  return _confirmOpenBankingConnection.apply(this, arguments);
}
function _confirmOpenBankingConnection() {
  _confirmOpenBankingConnection = _asyncToGenerator(function* (auth, connectionTaskId) {
    const pollingInterval = getPollingInterval();
    let status;
    while (typeof status === 'undefined' || status.status === 'processing') {
      yield timeout(pollingInterval);
      status = yield getOpenBankingConnectStatus(auth, connectionTaskId);
    }
    if (status.status === 'error') {
      throw new HttpError(getErrorHttpStatusCode$1(status.errorCode), status.message, {
        code: status.errorCode,
        payload: {
          provider: status.provider
        }
      });
    }
    return status;
  });
  return _confirmOpenBankingConnection.apply(this, arguments);
}

/**
 * Get a list of available account verification providers.
 *
 * @param auth - The authentication details for the request
 * @param options - Additional options to handle the request
 * @returns A map of provider IDs and provider data pairs
 * @public
 *
 * @example
 * ```javascript
 * const result = await getAccountVerificationProviders({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getAccountVerificationProviders(_x) {
  return _getAccountVerificationProviders.apply(this, arguments);
}
function _getAccountVerificationProviders() {
  _getAccountVerificationProviders = _asyncToGenerator(function* (auth, options = {}) {
    const {
      region,
      types
    } = options;
    const res = yield request(Version.v1, Namespace.accountVerification, {
      auth: auth,
      body: {
        region: region,
        types: _Array$isArray(types) ? types.join(',') : undefined
      },
      method: 'GET',
      path: '/providers'
    });
    return formatGetAccountProvidersResponse(res);
  });
  return _getAccountVerificationProviders.apply(this, arguments);
}

/**
 * Get the current status of an account verification provider authorization url task.
 *
 * @param auth - The authentication details for the request
 * @param taskId - The unique ID of the provider authorization task
 * @returns The details of the current status of the task
 * @public
 *
 * @example
 * ```javascript
 * const result = await getAccountVerificationProviderAuthorizationUrlStatus({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, '5cb43e7b-0e56-4d54-a17f-36a9c26eb60c')
 * ```
 */
function getAccountVerificationProviderAuthorizationUrlStatus(_x, _x2) {
  return _getAccountVerificationProviderAuthorizationUrlStatus.apply(this, arguments);
}
function _getAccountVerificationProviderAuthorizationUrlStatus() {
  _getAccountVerificationProviderAuthorizationUrlStatus = _asyncToGenerator(function* (auth, taskId) {
    const res = yield request(Version.v1, Namespace.accountVerification, {
      auth: auth,
      method: 'GET',
      path: `/authorisation-url/${taskId}`
    });
    return formatGetProviderAuthorizationUrlStatusResponse(res);
  });
  return _getAccountVerificationProviderAuthorizationUrlStatus.apply(this, arguments);
}

/**
 * Get a URL to authorize an account verification with the selected provider.
 *
 * @param auth - The authentication details for the request
 * @param providerId - The ID of the provider
 * @param redirectUrl - A URL to redirect to after the provider connection
 * @returns The provider authorization url
 * @public
 *
 * @example
 * ```javascript
 * const result = await getAccountVerificationProviderAuthorizationUrl({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, 'Monzo', 'https://www.thisisbud.com')
 * ```
 */
function getAccountVerificationProviderAuthorizationUrl(_x, _x2, _x3) {
  return _getAccountVerificationProviderAuthorizationUrl.apply(this, arguments);
}
function _getAccountVerificationProviderAuthorizationUrl() {
  _getAccountVerificationProviderAuthorizationUrl = _asyncToGenerator(function* (auth, providerId, redirectUrl) {
    const taskRes = yield request(Version.v1, Namespace.accountVerification, {
      auth: auth,
      body: {
        provider: providerId,
        redirect_url: redirectUrl
      },
      method: 'POST',
      path: '/authorisation-url'
    });
    const taskId = formatPostProviderAuthorizationUrlTaskResponse(taskRes);
    const pollingInterval = getPollingInterval();
    let response;
    // Poll the status until it is either `success` or `error` (not `processing`)
    while (typeof response === 'undefined' || response.status === 'processing') {
      yield timeout(pollingInterval);
      response = yield getAccountVerificationProviderAuthorizationUrlStatus(auth, taskId);
    }
    if (response.status === 'error') {
      throw new HttpError(getProviderAuthorizationUrlErrorHttpStatusCode(response.errorCode), response.message, {
        code: response.errorCode
      });
    }
    return response.url;
  });
  return _getAccountVerificationProviderAuthorizationUrl.apply(this, arguments);
}

/**
 * Get the current status of an account statement ingestion task.
 *
 * @param auth - The authentication details for the request or a function to get the authentication details for the request
 * @param taskId - The unique ID of the ingestion task
 * @returns The details of the current status of the task
 * @public
 *
 * @example
 * ```javascript
 * const result = await getIngestedAccountStatements({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, '5cb43e7b-0e56-4d54-a17f-36a9c26eb60c')
 * ```
 */
function getIngestAccountStatementStatus(_x, _x2) {
  return _getIngestAccountStatementStatus.apply(this, arguments);
}
function _getIngestAccountStatementStatus() {
  _getIngestAccountStatementStatus = _asyncToGenerator(function* (auth, taskId) {
    const res = yield request(Version.v1, Namespace.statementIngestion, {
      auth: auth,
      method: 'GET',
      path: `/statements/${encodeURIComponent(taskId)}`
    });
    return formatGetIngestAccountStatementStatusResponse(res);
  });
  return _getIngestAccountStatementStatus.apply(this, arguments);
}

/**
 * Initialize the ingestion of account statements for a given provider.
 * This must be called before ingesting any statements to ensure that the statements are correctly linked to the user.
 *
 * @param auth - The authentication details for the request or a function to get the authentication details for the request
 * @param providerId - The ID of the provider for which account statements are to be ingested
 * @public
 *
 * @example
 * ```javascript
 * await initIngestAccountStatements({
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, 'AU04301')
 * ```
 */
function initIngestAccountStatements(_x, _x2) {
  return _initIngestAccountStatements.apply(this, arguments);
}
function _initIngestAccountStatements() {
  _initIngestAccountStatements = _asyncToGenerator(function* (auth, providerId) {
    yield request(Version.v1, Namespace.statementIngestion, {
      auth: auth,
      headers: {
        'Content-Type': 'application/json',
        'X-Provider': providerId
      },
      method: 'POST',
      path: '/statements/initiate'
    });
  });
  return _initIngestAccountStatements.apply(this, arguments);
}

/**
 * Get the corresponding HTTP response status code for an ingestion error code.
 *
 * @param errorCode - The statement ingestion status error code
 * @returns A HTTP response status code
 */
function getErrorHttpStatusCode(errorCode) {
  switch (errorCode) {
    case IngestAccountStatementErrorCode.providerMismatch:
      return 400;
    case IngestAccountStatementErrorCode.fileTooLarge:
      return 413;
    case IngestAccountStatementErrorCode.parsingError:
      return 422;
    default:
      return 500;
  }
}
/**
 * Upload an account statement file to be ingested.
 *
 * @param auth - The authentication details for the request or a function to get the authentication details for the request
 * @param provider - The provider of the account statement
 * @param statementFile - The account statement PDF file to be ingested
 * @param options - Additional options to handle statement ingestion
 * @returns The details of the current status of the task
 * @public
 *
 * @example
 * ```javascript
 * const result = await ingestAccountStatement({
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, 'AU04301', new File([], 'account statement.pdf'))
 * ```
 */
function ingestAccountStatement(_x, _x2, _x3) {
  return _ingestAccountStatement.apply(this, arguments);
}
function _ingestAccountStatement() {
  _ingestAccountStatement = _asyncToGenerator(function* (auth, provider, statementFile, options = {}) {
    const {
      onProgress,
      statusPollingInterval = 5000
    } = options;
    const body = new FormData$1();
    body.append('file', statementFile);
    body.append('provider', provider);
    if (typeof onProgress === 'function') {
      onProgress('uploading');
    }
    const res = yield request(Version.v1, Namespace.statementIngestion, {
      auth: auth,
      body: body,
      method: 'POST',
      path: '/statements'
    });
    const taskId = formatPostIngestAccountStatementResponse(res);
    let status;
    if (typeof onProgress === 'function') {
      onProgress('processing');
    }
    // Poll the status until it is either `success` or `error` (not `processing`)
    while (typeof status === 'undefined' || status.status === 'processing') {
      yield timeout(statusPollingInterval);
      status = yield getIngestAccountStatementStatus(auth, taskId);
    }
    if (status.status === 'error') {
      throw new HttpError(getErrorHttpStatusCode(status.errorCode), status.message, {
        code: status.errorCode
      });
    }
    if (typeof onProgress === 'function') {
      onProgress('completed');
    }
  });
  return _ingestAccountStatement.apply(this, arguments);
}

/**
 * Get a queue of statements to be ingested.
 *
 * @param fileList - The list of files to be added to the queue
 * @returns A list of queue item descriptors containing a file index and file object
 */
function getStatementQueue(fileList) {
  var _context;
  return _mapInstanceProperty(_context = !_Array$isArray(fileList) ? _Array$from(fileList) : fileList).call(_context, function (file, index) {
    return {
      file,
      index
    };
  });
}
/**
 * Get the initial progress for all the statements in the queue.
 *
 * @param fileCount - The number of statements to be ingested.
 * @returns An array containing the initial status for each statement
 */
function getInitialProgress(fileCount) {
  var _context2;
  return _mapInstanceProperty(_context2 = [...new Array(fileCount)]).call(_context2, function () {
    return 'idle'; // Set all statement ingestion statuses to `idle` by default
  });
}
/**
 * Upload an account statement file to be ingested.
 *
 * @param auth - The authentication details for the request or a function to get the authentication details for the request
 * @param provider - The provider of the account statement
 * @param statementFiles - The account statement PDF files to be ingested
 * @param options - Additional options to handle statement ingestion
 * @returns The details of the current status of the task
 * @public
 *
 * @example
 * ```javascript
 * const result = await batchIngestAccountStatements({
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, 'AU04301', [new File([], 'account statement.pdf')])
 * ```
 */
function batchIngestAccountStatements(_x, _x2, _x3) {
  return _batchIngestAccountStatements.apply(this, arguments);
}
function _batchIngestAccountStatements() {
  _batchIngestAccountStatements = _asyncToGenerator(function* (auth, provider, statementFiles, options = {}) {
    const {
      abortOnError,
      maxConcurrentUploads = 3,
      onProgress,
      statusPollingInterval = 5000
    } = options;
    const queue = getStatementQueue(statementFiles);
    const fileCount = queue.length;
    let progress = getInitialProgress(queue.length);
    let completedCount = 0;
    let completed = false;
    // Initialize ingestion for the given provider
    yield initIngestAccountStatements(auth, provider);
    return new _Promise(function (resolve) {
      function startUpload() {
        return _startUpload.apply(this, arguments);
      } // Initiate as many uploads as allowed concurrently
      function _startUpload() {
        _startUpload = _asyncToGenerator(function* () {
          if (queue.length === 0) {
            return;
          }
          // Get the next statement in the queue to be ingested
          const {
            file,
            index
          } = queue.shift();
          try {
            yield ingestAccountStatement(auth, provider, file, {
              // Update the progress for the individual statement
              onProgress(statementProgress) {
                progress = [...progress];
                progress[index] = statementProgress;
                if (typeof onProgress === 'function') {
                  onProgress(progress);
                }
              },
              statusPollingInterval
            });
          } catch (err) {
            // Update the progress of the individual statement with the ingestion error
            progress = [...progress];
            progress[index] = err;
            // Abort the processing of other statements after the first error
            if (abortOnError === true) {
              completedCount = fileCount - 1; // Relies on the `completedCount++` below to set the completed count to the total number of statements
            }
          }

          completedCount++;
          // There are no ingestion tasks in progress or the task has been aborted
          if (completedCount === fileCount && !completed) {
            completed = true; // Prevent further `resolve()` calls when `abortOnError` is enabled
            resolve(progress);
            return;
          }
          // Start uploading the next statement in the queue
          startUpload(); // eslint-disable-line @typescript-eslint/no-floating-promises
        });
        return _startUpload.apply(this, arguments);
      }
      for (let i = 0; i < maxConcurrentUploads && queue.length !== 0; i++) {
        startUpload(); // eslint-disable-line @typescript-eslint/no-floating-promises
      }
    });
  });
  return _batchIngestAccountStatements.apply(this, arguments);
}

/**
 * Get a list of ingested account statements.
 *
 * @param auth - The authentication details for the request
 * @returns A list of ingested account statements
 * @public
 *
 * @example
 * ```javascript
 * const result = await getIngestedAccountStatements({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getIngestedAccountStatements(_x) {
  return _getIngestedAccountStatements.apply(this, arguments);
}
function _getIngestedAccountStatements() {
  _getIngestedAccountStatements = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.statementIngestion, {
      auth: auth,
      method: 'GET',
      path: '/statements'
    });
    return formatGetIngestedAccountStatementsResponse(res);
  });
  return _getIngestedAccountStatements.apply(this, arguments);
}

/**
 * Get the details of a single payment.
 *
 * @param auth - The authentication details for the request
 * @returns The details of the single payment
 * @public
 *
 * @example
 * ```javascript
 * const result = await getSinglePaymentDetails({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getSinglePaymentDetails(_x) {
  return _getSinglePaymentDetails.apply(this, arguments);
}
function _getSinglePaymentDetails() {
  _getSinglePaymentDetails = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.singlePayment, {
      auth: auth,
      method: 'GET',
      path: '/details'
    });
    return formatGetSinglePaymentDetailsResponse(res);
  });
  return _getSinglePaymentDetails.apply(this, arguments);
}

/**
 * Get a list of available single payment providers.
 *
 * @param auth - The authentication details for the request
 * @returns A map of provider IDs and provider data pairs
 * @public
 *
 * @example
 * ```javascript
 * const result = await getSinglePaymentProviders({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getSinglePaymentProviders(_x) {
  return _getSinglePaymentProviders.apply(this, arguments);
}
function _getSinglePaymentProviders() {
  _getSinglePaymentProviders = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.singlePayment, {
      auth: auth,
      method: 'GET',
      path: '/providers'
    });
    return formatGetPaymentProvidersResponse(res);
  });
  return _getSinglePaymentProviders.apply(this, arguments);
}

/**
 * Set a provider to handle a single payment.
 *
 * @param auth - The authentication details for the request
 * @param providerId - The ID of the provider to set
 * @public
 *
 * @example
 * ```javascript
 * await setSinglePaymentProvider(
 *   {
 *     nonce: '38158fa9baa47bfde34f',
 *     accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd'
 *   },
 *   'lloyds',
 * )
 * ```
 */
function setSinglePaymentProvider(_x, _x2) {
  return _setSinglePaymentProvider.apply(this, arguments);
}
function _setSinglePaymentProvider() {
  _setSinglePaymentProvider = _asyncToGenerator(function* (auth, providerId) {
    yield request(Version.v1, Namespace.singlePayment, {
      auth: auth,
      body: {
        provider: providerId
      },
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      path: '/provider'
    });
  });
  return _setSinglePaymentProvider.apply(this, arguments);
}

/**
 * Get current status of a single payment.
 *
 * @param auth - The authentication details for the request
 * @returns The current status of the single payment
 * @public
 *
 * @example
 * ```javascript
 * const result = await getSinglePaymentStatus({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getSinglePaymentStatus(_x) {
  return _getSinglePaymentStatus.apply(this, arguments);
}
function _getSinglePaymentStatus() {
  _getSinglePaymentStatus = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.singlePayment, {
      auth: auth,
      method: 'GET',
      path: '/status'
    });
    return formatGetPaymentStatusResponse(res);
  });
  return _getSinglePaymentStatus.apply(this, arguments);
}

/**
 * Get a single payment required fields for a given provider.
 *
 * @param auth - The authentication details for the request
 * @returns A list of required fields for the provider
 * @public
 *
 * @example
 * ```javascript
 * const result = await getSinglePaymentRequiredProviderFields({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getSinglePaymentProviderRequiredFields(_x) {
  return _getSinglePaymentProviderRequiredFields.apply(this, arguments);
}
function _getSinglePaymentProviderRequiredFields() {
  _getSinglePaymentProviderRequiredFields = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.singlePayment, {
      auth: auth,
      method: 'GET',
      path: '/provider/fields'
    });
    return formatGetProviderRequiredFieldsResponse(res);
  });
  return _getSinglePaymentProviderRequiredFields.apply(this, arguments);
}

/**
 * Set single payment field values for a given provider.
 *
 * @param auth - The authentication details for the request
 * @param fields - The fields to update on the single payment
 * @public
 *
 * @example
 * ```javascript
 * await setSinglePaymentProviderFieldValues({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, {
 *  iban: 'NL49RABO5350244469',
 *  account_holder_name: 'John Doe'
 * })
 * ```
 */
function setSinglePaymentProviderFieldValues(_x, _x2) {
  return _setSinglePaymentProviderFieldValues.apply(this, arguments);
}
function _setSinglePaymentProviderFieldValues() {
  _setSinglePaymentProviderFieldValues = _asyncToGenerator(function* (auth, fields) {
    yield request(Version.v1, Namespace.singlePayment, {
      auth: auth,
      body: fields,
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      path: '/provider/fields'
    });
  });
  return _setSinglePaymentProviderFieldValues.apply(this, arguments);
}

/**
 * Get a URL to authorize a single payment with the selected provider.
 *
 * @param auth - The authentication details for the request
 * @returns A URL to use for authorizing the single payment with the provider
 * @public
 *
 * @example
 * ```javascript
 * const result = await getSinglePaymentAuthorizationUrl({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getSinglePaymentAuthorizationUrl(_x) {
  return _getSinglePaymentAuthorizationUrl.apply(this, arguments);
}
function _getSinglePaymentAuthorizationUrl() {
  _getSinglePaymentAuthorizationUrl = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.singlePayment, {
      auth: auth,
      method: 'GET',
      path: '/authorisation'
    });
    return formatGetPaymentAuthorizationUrlResponse(res);
  });
  return _getSinglePaymentAuthorizationUrl.apply(this, arguments);
}

/**
 * Confirm a single payment.
 *
 * @param auth - The authentication details for the request
 * @public
 *
 * @example
 * ```javascript
 * await confirmSinglePayment({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function confirmSinglePayment(_x) {
  return _confirmSinglePayment.apply(this, arguments);
}
function _confirmSinglePayment() {
  _confirmSinglePayment = _asyncToGenerator(function* (auth) {
    yield request(Version.v1, Namespace.singlePayment, {
      auth: auth,
      method: 'POST',
      path: '/initiate'
    });
    const pollingInterval = getPollingInterval();
    let status;
    while (typeof status === 'undefined' || status.status === PaymentStatusCode.pending) {
      status = yield getSinglePaymentStatus(auth);
      if (status.status === PaymentStatusCode.error) {
        const statusCode = getPaymentErrorHttpStatusCode(status.errorCode);
        throw new HttpError(statusCode, status.status, {
          code: status.errorCode
        });
      }
      yield timeout(pollingInterval);
    }
  });
  return _confirmSinglePayment.apply(this, arguments);
}

/**
 * Get the details of a scheduled payment.
 *
 * @param auth - The authentication details for the request
 * @returns The details of the scheduled payment
 * @public
 *
 * @example
 * ```javascript
 * const result = await getScheduledPaymentDetails({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getScheduledPaymentDetails(_x) {
  return _getScheduledPaymentDetails.apply(this, arguments);
}
function _getScheduledPaymentDetails() {
  _getScheduledPaymentDetails = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.scheduledPayment, {
      auth: auth,
      method: 'GET',
      path: '/details'
    });
    return formatGetScheduledPaymentDetailsResponse(res);
  });
  return _getScheduledPaymentDetails.apply(this, arguments);
}

/**
 * Get a list of available scheduled payment providers.
 *
 * @param auth - The authentication details for the request
 * @returns A map of provider IDs and provider data pairs
 * @public
 *
 * @example
 * ```javascript
 * const result = await getScheduledPaymentProviders({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getScheduledPaymentProviders(_x) {
  return _getScheduledPaymentProviders.apply(this, arguments);
}
function _getScheduledPaymentProviders() {
  _getScheduledPaymentProviders = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.scheduledPayment, {
      auth: auth,
      method: 'GET',
      path: '/providers'
    });
    return formatGetPaymentProvidersResponse(res);
  });
  return _getScheduledPaymentProviders.apply(this, arguments);
}

/**
 * Set a provider to handle a scheduled payment.
 *
 * @param auth - The authentication details for the request
 * @param providerId - The ID of the provider to set
 * @public
 *
 * @example
 * ```javascript
 * await setScheduledPaymentProvider(
 *   {
 *     nonce: '38158fa9baa47bfde34f',
 *     accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd'
 *   },
 *   'lloyds',
 * )
 * ```
 */
function setScheduledPaymentProvider(_x, _x2) {
  return _setScheduledPaymentProvider.apply(this, arguments);
}
function _setScheduledPaymentProvider() {
  _setScheduledPaymentProvider = _asyncToGenerator(function* (auth, providerId) {
    yield request(Version.v1, Namespace.scheduledPayment, {
      auth: auth,
      body: {
        provider: providerId
      },
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      path: '/provider'
    });
  });
  return _setScheduledPaymentProvider.apply(this, arguments);
}

/**
 * Get a URL to authorize a scheduled payment with the selected provider.
 *
 * @param auth - The authentication details for the request
 * @returns A URL to use for authorizing the scheduled payment with the provider
 * @public
 *
 * @example
 * ```javascript
 * const result = await getScheduledPaymentAuthorizationUrl({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getScheduledPaymentAuthorizationUrl(_x) {
  return _getScheduledPaymentAuthorizationUrl.apply(this, arguments);
}
function _getScheduledPaymentAuthorizationUrl() {
  _getScheduledPaymentAuthorizationUrl = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.scheduledPayment, {
      auth: auth,
      method: 'GET',
      path: '/authorisation_url'
    });
    return formatGetPaymentAuthorizationUrlResponse(res);
  });
  return _getScheduledPaymentAuthorizationUrl.apply(this, arguments);
}

/**
 * Get current status of a scheduled payment.
 *
 * @param auth - The authentication details for the request
 * @returns The current status of the scheduled payment
 * @public
 *
 * @example
 * ```javascript
 * const result = await getScheduledPaymentStatus({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getScheduledPaymentStatus(_x) {
  return _getScheduledPaymentStatus.apply(this, arguments);
}
function _getScheduledPaymentStatus() {
  _getScheduledPaymentStatus = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.scheduledPayment, {
      auth: auth,
      method: 'GET',
      path: '/status'
    });
    return formatGetPaymentStatusResponse(res);
  });
  return _getScheduledPaymentStatus.apply(this, arguments);
}

/**
 * Confirm a scheduled payment.
 *
 * @param auth - The authentication details for the request
 * @public
 *
 * @example
 * ```javascript
 * await confirmScheduledPayment({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function confirmScheduledPayment(_x) {
  return _confirmScheduledPayment.apply(this, arguments);
}
function _confirmScheduledPayment() {
  _confirmScheduledPayment = _asyncToGenerator(function* (auth) {
    yield request(Version.v1, Namespace.scheduledPayment, {
      auth: auth,
      method: 'POST',
      path: '/confirm'
    });
    const pollingInterval = getPollingInterval();
    let status;
    while (typeof status === 'undefined' || status.status === PaymentStatusCode.pending) {
      status = yield getScheduledPaymentStatus(auth);
      if (status.status === PaymentStatusCode.error) {
        const statusCode = getPaymentErrorHttpStatusCode(status.errorCode);
        throw new HttpError(statusCode, status.status, {
          code: status.errorCode
        });
      } else if (status.status === PaymentStatusCode.success) {
        return;
      }
      yield timeout(pollingInterval);
    }
  });
  return _confirmScheduledPayment.apply(this, arguments);
}

/**
 * Get the details of a standing order.
 *
 * @param auth - The authentication details for the request
 * @returns The details of the standing order
 * @public
 *
 * @example
 * ```javascript
 * const result = await getStandingOrderDetails({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getStandingOrderDetails(_x) {
  return _getStandingOrderDetails.apply(this, arguments);
}
function _getStandingOrderDetails() {
  _getStandingOrderDetails = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.standingOrder, {
      auth: auth,
      method: 'GET',
      path: '/details'
    });
    return formatGetStandingOrderDetailsResponse(res);
  });
  return _getStandingOrderDetails.apply(this, arguments);
}

/**
 * Get a list of available standing order providers.
 *
 * @param auth - The authentication details for the request
 * @returns A map of provider IDs and provider data pairs
 * @public
 *
 * @example
 * ```javascript
 * const result = await getStandingOrderProviders({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getStandingOrderProviders(_x) {
  return _getStandingOrderProviders.apply(this, arguments);
}
function _getStandingOrderProviders() {
  _getStandingOrderProviders = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.standingOrder, {
      auth: auth,
      method: 'GET',
      path: '/providers'
    });
    return formatGetPaymentProvidersResponse(res);
  });
  return _getStandingOrderProviders.apply(this, arguments);
}

/**
 * Set a provider to handle a standing order.
 *
 * @param auth - The authentication details for the request
 * @param providerId - The ID of the provider to set
 * @public
 *
 * @example
 * ```javascript
 * await setStandingOrderProvider(
 *   {
 *     nonce: '38158fa9baa47bfde34f',
 *     accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd'
 *   },
 *   'lloyds',
 * )
 * ```
 */
function setStandingOrderProvider(_x, _x2) {
  return _setStandingOrderProvider.apply(this, arguments);
}
function _setStandingOrderProvider() {
  _setStandingOrderProvider = _asyncToGenerator(function* (auth, providerId) {
    yield request(Version.v1, Namespace.standingOrder, {
      auth: auth,
      body: {
        provider: providerId
      },
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      path: '/provider'
    });
  });
  return _setStandingOrderProvider.apply(this, arguments);
}

/**
 * Get a URL to authorize a standing order with the selected provider.
 *
 * @param auth - The authentication details for the request
 * @returns A URL to use for authorizing the standing order with the provider
 * @public
 *
 * @example
 * ```javascript
 * const result = await getStandingOrderAuthorizationUrl({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getStandingOrderAuthorizationUrl(_x) {
  return _getStandingOrderAuthorizationUrl.apply(this, arguments);
}
function _getStandingOrderAuthorizationUrl() {
  _getStandingOrderAuthorizationUrl = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.standingOrder, {
      auth: auth,
      method: 'GET',
      path: '/authorisation_url'
    });
    return formatGetPaymentAuthorizationUrlResponse(res);
  });
  return _getStandingOrderAuthorizationUrl.apply(this, arguments);
}

/**
 * Get current status of a standing order.
 *
 * @param auth - The authentication details for the request
 * @returns The current status of the standing order
 * @public
 *
 * @example
 * ```javascript
 * const result = await getStandingOrderStatus({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getStandingOrderStatus(_x) {
  return _getStandingOrderStatus.apply(this, arguments);
}
function _getStandingOrderStatus() {
  _getStandingOrderStatus = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.standingOrder, {
      auth: auth,
      method: 'GET',
      path: '/status'
    });
    return formatGetPaymentStatusResponse(res);
  });
  return _getStandingOrderStatus.apply(this, arguments);
}

/**
 * Confirm a standing order.
 *
 * @param auth - The authentication details for the request
 * @public
 *
 * @example
 * ```javascript
 * await confirmStandingOrder({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function confirmStandingOrder(_x) {
  return _confirmStandingOrder.apply(this, arguments);
}
function _confirmStandingOrder() {
  _confirmStandingOrder = _asyncToGenerator(function* (auth) {
    yield request(Version.v1, Namespace.standingOrder, {
      auth: auth,
      method: 'POST',
      path: '/confirm'
    });
    const pollingInterval = getPollingInterval();
    let status;
    while (typeof status === 'undefined' || status.status === PaymentStatusCode.pending) {
      status = yield getStandingOrderStatus(auth);
      if (status.status === PaymentStatusCode.error) {
        const statusCode = getPaymentErrorHttpStatusCode(status.errorCode);
        throw new HttpError(statusCode, status.status, {
          code: status.errorCode
        });
      } else if (status.status === PaymentStatusCode.success) {
        return;
      }
      yield timeout(pollingInterval);
    }
  });
  return _confirmStandingOrder.apply(this, arguments);
}

/**
 * Create an OAuth token for an affordability meeting.
 *
 * @param auth - The authentication details for the request
 * @public
 *
 * @example
 * ```javascript
 * await createMeetingOAuthToken({
 *   connectionId: '19db0a52-348c-4aa7-a3ed-fbe492994de2',
 *   meetingId: '00ac9aee-ccaa-4455-95b9-4a517662544a',
 *   nonce: '38158fa9baa47bfde34f',
 * })
 * ```
 */
function createMeetingOAuthToken(_x) {
  return _createMeetingOAuthToken.apply(this, arguments);
}
function _createMeetingOAuthToken() {
  _createMeetingOAuthToken = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.meetings, {
      body: {
        connection_id: auth.connectionId,
        grant_type: 'authorization_code',
        meeting_id: auth.meetingId,
        nonce: auth.nonce
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      path: '/oauth/token'
    });
    return formatPostOAuthTokenResponse(res);
  });
  return _createMeetingOAuthToken.apply(this, arguments);
}

/**
 * Refresh an existing OAuth token for an affordability meeting.
 *
 * @param auth - The authentication details for the request
 * @public
 *
 * @example
 * ```javascript
 * await refreshMeetingOAuthToken({
 *   connectionId: '19db0a52-348c-4aa7-a3ed-fbe492994de2',
 *   meetingId: '00ac9aee-ccaa-4455-95b9-4a517662544a',
 *   refreshToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function refreshMeetingOAuthToken(_x) {
  return _refreshMeetingOAuthToken.apply(this, arguments);
}
function _refreshMeetingOAuthToken() {
  _refreshMeetingOAuthToken = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.meetings, {
      body: {
        connection_id: auth.connectionId,
        grant_type: 'refresh_token',
        meeting_id: auth.meetingId,
        refresh_token: auth.refreshToken
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      path: '/oauth/token'
    });
    return formatPostOAuthTokenResponse(res);
  });
  return _refreshMeetingOAuthToken.apply(this, arguments);
}

/**
 * Get the configuration for an Affordability Dashboard client.
 *
 * @param auth - The authentication details for the request
 * @returns The configuration for the Affordability Dashboard client to be used by the current user
 * @public
 *
 * @example
 * ```javascript
 * const result = await getAffordabilityDashboardConfig({
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getAffordabilityDashboardConfig(_x) {
  return _getAffordabilityDashboardConfig.apply(this, arguments);
}
function _getAffordabilityDashboardConfig() {
  _getAffordabilityDashboardConfig = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.clientConfig, {
      auth: auth,
      method: 'GET',
      path: '/'
    });
    return formatGetAffordabilityDashboardConfig(res);
  });
  return _getAffordabilityDashboardConfig.apply(this, arguments);
}

/**
 * Normalize the details for the main applicant.
 *
 * @param details - The details of the meeting
 * @returns The normalized details of the main applicant
 */
function normalizeMainApplicant(details) {
  // Handle current data format
  if (typeof details.applicants !== 'undefined') {
    return details.applicants[0];
  }
  // Handle legacy data format
  return details.mainApplicant;
}
/**
 * Normalize the details for the joint applicants.
 *
 * @param details - The details of the meeting
 * @returns The normalized details of the joint applicants
 */
function normalizeJointApplicants(details) {
  // Handle current data format
  if (typeof details.applicants !== 'undefined') {
    var _context;
    return _sliceInstanceProperty(_context = details.applicants).call(_context, 1);
    // Handle legacy data format
  } else if (typeof details.jointApplicant !== 'undefined') {
    return [details.jointApplicant];
  }
  return [];
}
/**
 * Create a meeting between an advisor and a customer.
 *
 * @param auth - The authentication details for the request
 * @param details - The details of the meeting
 * @returns The ID of the meeting created
 * @public
 *
 * @example
 * ```javascript
 * await createMeeting({
 *   nonce: '38158fa9baa47bfde34f',
 *   token: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, {
 *   accountConnectionInitiator: 'advisor',
 *   applicants: [
 *     {
 *       firstName: 'John',
 *       lastName: 'Doe',
 *     }
 *   ],
 *   date: new Date('2021-10-08T16:00:00.000Z'),
 * })
 * ```
 */
function createMeeting(_x, _x2) {
  return _createMeeting.apply(this, arguments);
}
function _createMeeting() {
  _createMeeting = _asyncToGenerator(function* (auth, details) {
    const {
      dataBroker
    } = details;
    const mainApplicant = normalizeMainApplicant(details);
    const jointApplicants = normalizeJointApplicants(details);
    const res = yield request(Version.v1, Namespace.meetings, {
      auth: auth,
      body: {
        application_type: jointApplicants.length === 0 ? 'single' : 'joint',
        appointment_date: toUTCDateString(details.date),
        metadata: {
          account_connection_initiator: details.accountConnectionInitiator,
          advisor_name: details.advisorName,
          application_id: details.applicationId,
          customer_email: mainApplicant.email,
          customer_id: mainApplicant.customerId,
          data_broker_name: dataBroker === null || dataBroker === void 0 ? void 0 : dataBroker.name,
          data_broker_organization: dataBroker === null || dataBroker === void 0 ? void 0 : dataBroker.organization
        },
        primary_applicant: {
          first_name: mainApplicant.firstName,
          last_name: mainApplicant.lastName
        },
        secondary_applicants: _mapInstanceProperty(jointApplicants).call(jointApplicants, function (applicant) {
          return {
            first_name: applicant.firstName,
            last_name: applicant.lastName
          };
        })
      },
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      path: '/'
    });
    return res.data.meeting_id;
  });
  return _createMeeting.apply(this, arguments);
}

/**
 * Format a credit/debit indicator for use with an API query.
 *
 * @param cdi - The credit/debit indicator to format
 * @returns A formatted credit/debit indicator
 */
function formatCdiQuery(cdi) {
  switch (cdi) {
    case 'credit':
      return 'Credit';
    case 'debit':
      return 'Debit';
    default:
      throw new Error(`Unsupported CDI filter: ${cdi}`);
  }
}
/**
 * Format a list of strings for use in an API query.
 *
 * @param list - The list of strings to be formatted
 * @returns A comma-separated list of strings
 */
function formatListQuery$1(list) {
  return list.join(',');
}
/**
 * Format the tags to be included in the transactions request.
 *
 * @param options - The request options
 * @returns The formatted tags to include in the transactions request
 */
function formatIncludeTags(options) {
  const {
    benefit,
    debtCollection,
    internal,
    oneOff,
    regular,
    salary
  } = options;
  const tags = [];
  if (benefit === true) {
    tags.push('benefit');
  }
  if (debtCollection === true) {
    tags.push('debt-collection');
  }
  if (internal === true) {
    tags.push('internal-transfer');
  }
  if (oneOff === true) {
    tags.push('one-off-transaction');
  }
  if (regular === true) {
    tags.push('regular-transaction');
  }
  if (salary === true) {
    tags.push('salary');
  }
  return tags;
}
/**
 * Format the tags to be excluded from the transactions request.
 *
 * @param options - The request options
 * @returns The formatted tags to exclude from the transactions request
 */
function formatExcludeTags(options) {
  const {
    benefit,
    debtCollection,
    internal,
    oneOff,
    regular,
    salary
  } = options;
  const tags = [];
  if (benefit === false) {
    tags.push('benefit');
  }
  if (debtCollection === false) {
    tags.push('debt-collection');
  }
  if (internal === false) {
    tags.push('internal-transfer');
  }
  if (oneOff === false) {
    tags.push('one-off-transaction');
  }
  if (regular === false) {
    tags.push('regular-transaction');
  }
  if (salary === false) {
    tags.push('salary');
  }
  return tags;
}
/**
 * Build an API request query.
 *
 * @param options - The query options
 * @returns The formatted query object
 */
function formatQuery$3(options) {
  const {
    category,
    cdi,
    frequency,
    from,
    ids,
    subCategory,
    to
  } = options;
  const query = {};
  const includeTags = formatIncludeTags(options);
  const excludeTags = formatExcludeTags(options);
  if (typeof category !== 'undefined') {
    query['attribute[client_category_l1]'] = kebabCaseToSnakeCase(category);
  }
  if (typeof subCategory !== 'undefined') {
    query['attribute[client_category_l2]'] = kebabCaseToSnakeCase(subCategory);
  }
  if (typeof frequency !== 'undefined') {
    query['attribute[regular-payment-frequency]'] = formatApiTransactionFrequency(frequency);
  }
  if (typeof cdi !== 'undefined') {
    query.cdi = formatCdiQuery(cdi);
  }
  if (typeof from !== 'undefined') {
    query.date_from = from.toISOString();
  }
  if (typeof to !== 'undefined') {
    query.date_to = to.toISOString();
  }
  if (typeof ids !== 'undefined' && ids.length) {
    query.transaction_ids = formatListQuery$1(ids);
  }
  if (includeTags.length) {
    query.tags = includeTags;
  }
  if (excludeTags.length) {
    query.not_tags = excludeTags;
  }
  return query;
}
/**
 * Get a list of available transactions associated with a meeting.
 *
 * @param auth - The authentication details for the request
 * @param options - Additional options to handle the request
 * @returns A list of transactions
 * @public
 *
 * @example
 * ```javascript
 * const result = await getMeetingTransactions({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getMeetingTransactions(_x) {
  return _getMeetingTransactions.apply(this, arguments);
}
function _getMeetingTransactions() {
  _getMeetingTransactions = _asyncToGenerator(function* (auth, options = {}) {
    const res = yield request(Version.v1, Namespace.meetings, {
      auth: auth,
      body: formatQuery$3(options),
      method: 'GET',
      path: '/financial-data/transactions'
    });
    return formatGetMeetingTransactionsResponse(res);
  });
  return _getMeetingTransactions.apply(this, arguments);
}

/**
 * Build an API request query.
 *
 * @param options - The query options
 * @returns The formatted query object
 */
function formatQuery$2(options) {
  const {
    from,
    matchCategory,
    matchCdi = true,
    matchFrequency,
    matchReference = true,
    matchSubCategory,
    sorting,
    to
  } = options;
  const query = {};
  const valueMatches = [];
  if (typeof from !== 'undefined') {
    query.date_from = from.toISOString();
  }
  if (typeof to !== 'undefined') {
    query.date_to = to.toISOString();
  }
  if (typeof sorting !== 'undefined') {
    query.order_by = sorting;
  }
  if (matchCdi) {
    valueMatches.push('cdi');
  }
  if (matchReference) {
    valueMatches.push('reference');
  }
  if (matchCategory === true) {
    valueMatches.push('attribute[client_category_l1]');
  }
  if (matchSubCategory === true) {
    valueMatches.push('attribute[client_category_l2]');
  }
  if (matchFrequency === true) {
    valueMatches.push('attribute[regular-payment-frequency]');
  }
  if (!valueMatches.length) {
    throw new Error('There are no active matchers for fetching similar transactions');
  }
  query.with_same_value = valueMatches.join(',');
  return query;
}
/**
 * Get a list of available similar transactions to another transaction.
 *
 * @remarks By default transactions are matched by CDI and reference.
 *
 * @param auth - The authentication details for the request
 * @param transactionId - The ID of the transaction to match
 * @param options - Additional options to handle the request
 * @returns A list of transactions
 * @public
 *
 * @example
 * ```javascript
 * const result = await getSimilarMeetingTransactions({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, 'c0f76bc2-5659-4f0b-b98a-1ec882e8b82f')
 * ```
 */
function getSimilarMeetingTransactions(_x, _x2) {
  return _getSimilarMeetingTransactions.apply(this, arguments);
}
function _getSimilarMeetingTransactions() {
  _getSimilarMeetingTransactions = _asyncToGenerator(function* (auth, transactionId, options = {}) {
    const res = yield request(Version.v1, Namespace.meetings, {
      auth: auth,
      body: formatQuery$2(options),
      method: 'GET',
      path: `/financial-data/transactions/similar/${encodeURIComponent(transactionId)}`
    });
    return formatGetMeetingTransactionsResponse(res);
  });
  return _getSimilarMeetingTransactions.apply(this, arguments);
}

/**
 * Format a list of strings for use in an API query.
 *
 * @param list - The list of strings to be formatted
 * @returns A comma-separated list of strings
 */
function formatListQuery(list) {
  return list.join(',');
}
/**
 * Build an API request query.
 *
 * @param options - The query options
 * @returns The formatted query object
 */
function formatQuery$1(options) {
  const {
    benefit,
    debtCollection,
    frequency,
    from,
    ids,
    internal,
    oneOff,
    regular,
    salary,
    to
  } = options;
  const query = {};
  const includeTags = [];
  const excludeTags = [];
  if (typeof frequency !== 'undefined') {
    query['attribute[regular-payment-frequency]'] = formatApiTransactionFrequency(frequency);
  }
  if (typeof from !== 'undefined') {
    query.date_from = from.toISOString();
  }
  if (typeof to !== 'undefined') {
    query.date_to = to.toISOString();
  }
  if (typeof ids !== 'undefined' && ids.length) {
    query.transaction_ids = formatListQuery(ids);
  }
  if (benefit === true) {
    includeTags.push('benefit');
  } else if (benefit === false) {
    excludeTags.push('benefit');
  }
  if (debtCollection === true) {
    includeTags.push('debt-collection');
  } else if (debtCollection === false) {
    excludeTags.push('debt-collection');
  }
  if (internal === true) {
    includeTags.push('internal-transfer');
  } else if (internal === false) {
    excludeTags.push('internal-transfer');
  }
  if (oneOff === true) {
    includeTags.push('one-off-transaction');
  } else if (oneOff === false) {
    excludeTags.push('one-off-transaction');
  }
  if (regular === true) {
    includeTags.push('regular-transaction');
  } else if (regular === false) {
    excludeTags.push('regular-transaction');
  }
  if (salary === true) {
    includeTags.push('salary');
  } else if (salary === false) {
    excludeTags.push('salary');
  }
  if (includeTags.length) {
    query.tags = includeTags;
  }
  if (excludeTags.length) {
    query.not_tags = excludeTags;
  }
  return query;
}
/**
 * Get a list of available transactions associated with a meeting that are considered to be "other" income.
 *
 * @param auth - The authentication details for the request
 * @param options - Additional options to handle the request
 * @returns A list of transactions
 * @public
 *
 * @example
 * ```javascript
 * const result = await getOtherIncomeMeetingTransactions({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getOtherIncomeMeetingTransactions(_x) {
  return _getOtherIncomeMeetingTransactions.apply(this, arguments);
}
function _getOtherIncomeMeetingTransactions() {
  _getOtherIncomeMeetingTransactions = _asyncToGenerator(function* (auth, options = {}) {
    const res = yield request(Version.v1, Namespace.meetings, {
      auth: auth,
      body: formatQuery$1(options),
      method: 'GET',
      path: '/financial-data/transactions/other-incoming'
    });
    return formatGetMeetingTransactionsResponse(res);
  });
  return _getOtherIncomeMeetingTransactions.apply(this, arguments);
}

/**
 * Formats the attributes to be updated.
 *
 * @param options - The request options
 * @returns The formatted attributes
 */
function formatAttributes(options) {
  const {
    category,
    frequency,
    subCategory
  } = options;
  const attrs = {};
  if (typeof category !== 'undefined') {
    attrs.client_category_l1 = [kebabCaseToSnakeCase(category)];
  }
  if (typeof subCategory !== 'undefined') {
    attrs.client_category_l2 = [kebabCaseToSnakeCase(subCategory)];
  }
  if (typeof frequency !== 'undefined') {
    attrs['regular-payment-frequency'] = frequency === null ? [''] : [formatApiTransactionFrequency(frequency)];
  }
  return attrs;
}
/**
 * Format the tags to be added to the transactions.
 *
 * @param options - The request options
 * @returns The formatted tags to add to the transactions
 */
function formatTags(options) {
  const {
    benefit,
    debtCollection,
    internal,
    oneOff,
    regular,
    salary
  } = options;
  const tags = [];
  if (benefit === true) {
    tags.push('benefit');
  }
  if (debtCollection === true) {
    tags.push('debt-collection');
  }
  if (internal === true) {
    tags.push('internal-transfer');
  }
  if (oneOff === true) {
    tags.push('one-off-transaction');
  }
  if (regular === true) {
    tags.push('regular-transaction');
  }
  if (salary === true) {
    tags.push('salary');
  }
  return tags;
}
/**
 * Format the tags to be removed from the transactions.
 *
 * @param options - The request options
 * @returns The formatted tags to remove from the transactions
 */
function formatRemoveTags(options) {
  const {
    benefit,
    debtCollection,
    internal,
    oneOff,
    regular,
    salary
  } = options;
  const tags = [];
  if (benefit === false) {
    tags.push('benefit');
  }
  if (debtCollection === false) {
    tags.push('debt-collection');
  }
  if (internal === false) {
    tags.push('internal-transfer');
  }
  if (oneOff === false) {
    tags.push('one-off-transaction');
  }
  if (regular === false) {
    tags.push('regular-transaction');
  }
  if (salary === false) {
    tags.push('salary');
  }
  return tags;
}
/**
 * Update multiple transactions with different attributes.
 *
 * @param auth - The authentication details for the request
 * @param transactionIds - The IDs of the transactions to update
 * @param options - Additional options to handle the request
 * @returns The number of tran
 * @public
 *
 * @example
 * ```javascript
 * await updateMeetingTransactions({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, ['c0f76bc2-5659-4f0b-b98a-1ec882e8b82f'], {
 *   frequency: 'monthly',
 * })
 * ```
 */
function updateMeetingTransactions(_x, _x2) {
  return _updateMeetingTransactions.apply(this, arguments);
}
function _updateMeetingTransactions() {
  _updateMeetingTransactions = _asyncToGenerator(function* (auth, transactionIds, options = {}) {
    const attrs = formatAttributes(options);
    const tags = formatTags(options);
    const removeTags = formatRemoveTags(options);
    yield request(Version.v1, Namespace.meetings, {
      auth: auth,
      body: _mapInstanceProperty(transactionIds).call(transactionIds, function (transactionId) {
        return {
          attributes: attrs,
          criteria: {
            match: 'TransactionID',
            values: {
              transaction_id: transactionId
            }
          },
          remove_tags: removeTags,
          tags: tags
        };
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      path: '/financial-data/transactions/corrections'
    });
  });
  return _updateMeetingTransactions.apply(this, arguments);
}

/**
 * Delete the financial data associated with a meeting.
 *
 * @remarks The meeting details will remain available
 * @param auth - The authentication details for the request
 * @public
 *
 * @example
 * ```javascript
 * await deleteMeetingFinancialData({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function deleteMeetingFinancialData(_x) {
  return _deleteMeetingFinancialData.apply(this, arguments);
}
function _deleteMeetingFinancialData() {
  _deleteMeetingFinancialData = _asyncToGenerator(function* (auth) {
    yield request(Version.v1, Namespace.meetings, {
      auth: auth,
      method: 'DELETE',
      path: '/financial-data'
    });
  });
  return _deleteMeetingFinancialData.apply(this, arguments);
}

/**
 * Get the list of available meetings.
 *
 * @remarks By default, any meetings that had their financial data deleted are excluded from the list
 * @param auth - The authentication details for the request
 * @param options - Additional options to handle the request
 * @returns The list of available meetings
 * @public
 *
 * @example
 * ```javascript
 * const result = await getMeetings({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getMeetings(_x) {
  return _getMeetings.apply(this, arguments);
}
function _getMeetings() {
  _getMeetings = _asyncToGenerator(function* (auth, options = {}) {
    const {
      createdBy,
      excludeDataDeleted = true
    } = options;
    const res = yield request(Version.v1, Namespace.meetings, {
      auth: auth,
      body: {
        booked_by: createdBy
      },
      method: 'GET',
      path: '/'
    });
    const meetings = formatGetMeetingsResponse(res);
    if (excludeDataDeleted) {
      return _filterInstanceProperty(meetings).call(meetings, function (meeting) {
        return !meeting.dataDeleted;
      });
    }
    return meetings;
  });
  return _getMeetings.apply(this, arguments);
}

/**
 * Get the details of a meeting.
 *
 * @param auth - The authentication details for the request
 * @param meetingId - The unique ID of the meeting
 * @returns The details of the requested meeting
 * @public
 *
 * @example
 * ```javascript
 * const result = await getMeetingDetails({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, '8dd6b589-7ad2-4555-b84e-9ee349c62521')
 * ```
 */
function getMeetingDetails(_x, _x2) {
  return _getMeetingDetails.apply(this, arguments);
}
function _getMeetingDetails() {
  _getMeetingDetails = _asyncToGenerator(function* (auth, meetingId) {
    const res = yield request(Version.v1, Namespace.meetings, {
      auth: auth,
      method: 'GET',
      path: meetingId
    });
    return formatGetMeetingDetailsResponse(res);
  });
  return _getMeetingDetails.apply(this, arguments);
}

/**
 * Normalizes the value of a review status from the meeting details into an api compatible value.
 *
 * @param details - The meeting details
 * @returns The normalized review status
 */
function normalizeReviewStatus(details) {
  const {
    reviewStatus
  } = details;
  if (reviewStatus === MeetingReviewStatus.reviewed) {
    return 'reviewed';
  } else if (reviewStatus === MeetingReviewStatus.pending) {
    return '';
  } else if (typeof reviewStatus === 'undefined' && details.hasOwnProperty('reviewStatus')) {
    return '';
  } else if (typeof reviewStatus === 'undefined') {
    return undefined;
  }
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  throw new Error(`Invalid review status provided: '${reviewStatus}'`);
}
/**
 * Update the details of a meeting.
 *
 * @param auth - The authentication details for the request
 * @param meetingId - The unique ID of the meeting to update
 * @param details - The meeting details to be updated
 * @public
 *
 * @example
 * ```javascript
 * const result = await updateMeetingDetails(
 *   {
 *     nonce: '38158fa9baa47bfde34f',
 *     accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 *   },
 *   '8dd6b589-7ad2-4555-b84e-9ee349c62521',
 *   {
 *     date: new Date(2021, 10, 2),
 *   },
 * )
 * ```
 */
function updateMeetingDetails(_x, _x2, _x3) {
  return _updateMeetingDetails.apply(this, arguments);
}
function _updateMeetingDetails() {
  _updateMeetingDetails = _asyncToGenerator(function* (auth, meetingId, details) {
    const {
      date
    } = details;
    yield request(Version.v1, Namespace.meetings, {
      auth: auth,
      body: {
        appointment_date: typeof date !== 'undefined' ? toUTCDateString(date) : undefined,
        review_status: normalizeReviewStatus(details)
      },
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'PATCH',
      path: meetingId
    });
  });
  return _updateMeetingDetails.apply(this, arguments);
}

function formatGroupByQuery(groupBy = ['category', 'subCategory']) {
  return _mapInstanceProperty(groupBy).call(groupBy, function (key) {
    switch (key) {
      case 'category':
        return 'client_category_l1';
      case 'subCategory':
        return 'client_category_l2';
      case 'frequency':
        return 'regular-payment-frequency';
      default:
        throw new Error(`Unsupported transaction totals grouping option: ${key}`);
    }
  });
}
/**
 * Build an API request query.
 *
 * @param options - The query options
 * @returns The formatted query object
 */
function formatQuery(options) {
  const {
    category,
    benefit,
    debtCollection,
    frequency,
    from,
    groupBy,
    internal,
    oneOff,
    regular,
    salary,
    subCategory,
    to,
    timezone
  } = options;
  const query = {
    group_by: formatGroupByQuery(groupBy)
  };
  const includeTags = [];
  const excludeTags = [];
  if (typeof category !== 'undefined') {
    query['attribute[client_category_l1]'] = kebabCaseToSnakeCase(category);
  }
  if (typeof subCategory !== 'undefined') {
    query['attribute[client_category_l2]'] = kebabCaseToSnakeCase(subCategory);
  }
  if (typeof frequency !== 'undefined') {
    query['attribute[regular-payment-frequency]'] = formatApiTransactionFrequency(frequency);
  }
  if (typeof from !== 'undefined') {
    query.date_from = from.toISOString();
  }
  if (typeof to !== 'undefined') {
    query.date_to = to.toISOString();
  }
  if (benefit === true) {
    includeTags.push('benefit');
  } else if (benefit === false) {
    excludeTags.push('benefit');
  }
  if (debtCollection === true) {
    includeTags.push('debt-collection');
  } else if (debtCollection === false) {
    excludeTags.push('debt-collection');
  }
  if (internal === true) {
    includeTags.push('internal-transfer');
  } else if (internal === false) {
    excludeTags.push('internal-transfer');
  }
  if (oneOff === true) {
    includeTags.push('one-off-transaction');
  } else if (oneOff === false) {
    excludeTags.push('one-off-transaction');
  }
  if (regular === true) {
    includeTags.push('regular-transaction');
  } else if (regular === false) {
    excludeTags.push('regular-transaction');
  }
  if (salary === true) {
    includeTags.push('salary');
  } else if (salary === false) {
    excludeTags.push('salary');
  }
  if (includeTags.length) {
    query.tags = includeTags;
  }
  if (excludeTags.length) {
    query.not_tags = excludeTags;
  }
  if (typeof timezone === 'string') {
    query.timezone = timezone;
  }
  return query;
}
/**
 * Get a list of available transactions associated with a meeting.
 *
 * @remarks By default the totals will be grouped by category and sub-category.
 * @remarks Amounts in currencies other than the specified one will be ignored.
 * @param auth - The authentication details for the request
 * @param options - Additional options to handle the request
 * @returns A list of transactions
 * @public
 *
 * @example
 * ```javascript
 * const result = await getMeetingTransactionTotals({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getMeetingTransactionTotals(_x, _x2) {
  return _getMeetingTransactionTotals.apply(this, arguments);
}
function _getMeetingTransactionTotals() {
  _getMeetingTransactionTotals = _asyncToGenerator(function* (auth, options) {
    const {
      currency
    } = options;
    const res = yield request(Version.v1, Namespace.meetings, {
      auth: auth,
      body: formatQuery(options),
      method: 'GET',
      path: '/financial-data/totals'
    });
    return formatGetTransactionTotalsResponse(res, currency);
  });
  return _getMeetingTransactionTotals.apply(this, arguments);
}

const formatBody = options => {
  const {
    from,
    to,
    timezone
  } = options;
  return _objectSpread(_objectSpread(_objectSpread({}, from && {
    date_from: from.toISOString()
  }), to && {
    date_to: to.toISOString()
  }), {}, {
    timezone
  });
};
/**
 * Get the financial report for a meeting.
 *
 * @param auth - The authentication details for the request
 * @param meetingId - The unique ID of the meeting for which the report is being requested
 * @param options - Additional options to handle the request
 * @returns The financial report for the meeting
 * @public
 *
 * @example
 * ```javascript
 * const result = await getMeetingReport({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, '8dd6b589-7ad2-4555-b84e-9ee349c62521')
 * ```
 */
function getMeetingReport(_x, _x2) {
  return _getMeetingReport.apply(this, arguments);
}
function _getMeetingReport() {
  _getMeetingReport = _asyncToGenerator(function* (auth, meetingId, options = {}) {
    const res = yield request(Version.v1, Namespace.meetings, {
      auth: _objectSpread(_objectSpread({}, auth), {}, {
        meetingId
      }),
      body: formatBody(options),
      method: 'GET',
      path: '/financial-data/report'
    });
    return formatGetMeetingReportResponse(res);
  });
  return _getMeetingReport.apply(this, arguments);
}

/**
 * Create an Agent Flow OAuth token.
 *
 * @param auth - The authentication details for the request
 * @public
 *
 * @example
 * ```javascript
 * await createAgentFlowOAuthToken({
 *   nonce: '38158fa9baa47bfde34f',
 *   token: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function createAgentFlowOAuthToken(_x) {
  return _createAgentFlowOAuthToken.apply(this, arguments);
}
function _createAgentFlowOAuthToken() {
  _createAgentFlowOAuthToken = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.oAuth, {
      body: {
        grant_type: 'authorization_code',
        nonce: auth.nonce,
        token: auth.token
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      path: '/token'
    });
    return formatAgentFlowOAuthTokenResponse(res);
  });
  return _createAgentFlowOAuthToken.apply(this, arguments);
}

/**
 * Refresh an existing Agent Flow OAuth token.
 *
 * @param auth - The authentication details for the request
 * @public
 *
 * @example
 * ```javascript
 * await refreshAgentFlowOAuthToken({
 *   nonce: '38158fa9baa47bfde34f',
 *   refreshToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function refreshAgentFlowOAuthToken(_x) {
  return _refreshAgentFlowOAuthToken.apply(this, arguments);
}
function _refreshAgentFlowOAuthToken() {
  _refreshAgentFlowOAuthToken = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.oAuth, {
      body: {
        grant_type: 'refresh_token',
        nonce: auth.nonce,
        refresh_token: auth.refreshToken
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      path: '/token'
    });
    return formatAgentFlowOAuthTokenResponse(res);
  });
  return _refreshAgentFlowOAuthToken.apply(this, arguments);
}

/**
 * Get the configuration for an Agent Flow connection.
 *
 * @param auth - The authentication details for the request
 * @returns The configuration for the current agent flow connection
 * @public
 *
 * @example
 * ```javascript
 * const result = await getAgentFlowConfig({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * })
 * ```
 */
function getAgentFlowConfig(_x) {
  return _getAgentFlowConfig.apply(this, arguments);
}
function _getAgentFlowConfig() {
  _getAgentFlowConfig = _asyncToGenerator(function* (auth) {
    const res = yield request(Version.v1, Namespace.clientConfigs, {
      auth: auth,
      method: 'GET',
      path: '/'
    });
    return formatGetAgentFlowConfigResponse(res);
  });
  return _getAgentFlowConfig.apply(this, arguments);
}

/**
 * Get a form with fields needed to login to a given provider.
 *
 * @param auth - The authentication details for the request
 * @param providerId - The ID of the provider
 * @returns The taskId and list of login fields
 * @public
 *
 * @example
 * ```javascript
 * const result = await getScrapingProviderLoginForm({
 *   nonce: '38158fa9baa47bfde34f',
 *   accessToken: '1f47a0edbde64d06ac528d59b87975acc6830dbd',
 * }, 'monzo')
 * ```
 */
function getScrapingProviderLoginForm(_x, _x2) {
  return _getScrapingProviderLoginForm.apply(this, arguments);
}
function _getScrapingProviderLoginForm() {
  _getScrapingProviderLoginForm = _asyncToGenerator(function* (auth, providerId) {
    const res = yield request(Version.v1, Namespace.screenScraping, {
      auth: auth,
      method: 'GET',
      path: `/form/${encodeURIComponent(providerId)}`
    });
    return formatGetProviderLoginFormResponse(res);
  });
  return _getScrapingProviderLoginForm.apply(this, arguments);
}

class OAuthFlow {
  /**
   * Creates a flow to create and refresh oAuth access tokens.
   *
   * @remarks This flow is not meant to be used directly, instead it should be extended by other flows
   * @param nonce - A nonce value for the requests
   * @param token - A single use token to be exchanged for an oAuth access token
   * @param initialAuth - An optional parameter with previously fetched oAuth details
   */
  constructor(nonce, token, initialAuth) {
    /**
     * A nonce value for the requests
     */
    _defineProperty(this, "nonce", void 0);
    /**
     * The oAuth access token obtained
     */
    _defineProperty(this, "accessToken", void 0);
    /**
     * The date and time at which the oAuth access token is to expire and needs to be refreshed
     */
    _defineProperty(this, "accessTokenExpiry", void 0);
    /**
     * A token to be used for refreshing an expired or nearly expired oAuth access token
     */
    _defineProperty(this, "refreshToken", void 0);
    /**
     * A single use token to be exchanged for an oAuth access token
     */
    _defineProperty(this, "token", void 0);
    this.nonce = nonce;
    this.token = token;
    this.accessToken = initialAuth === null || initialAuth === void 0 ? void 0 : initialAuth.accessToken;
    this.accessTokenExpiry = initialAuth === null || initialAuth === void 0 ? void 0 : initialAuth.expires;
    this.refreshToken = initialAuth === null || initialAuth === void 0 ? void 0 : initialAuth.refreshToken;
  }
  /**
   * Require an oAuth access token.
   *
   * @remarks If an access token has not been created yet, one will be created
   * @remarks If an access token has expired, it will be refreshed
   * @remarks If an access token has been created and is still valid, it will be returned
   *
   * @returns A valid oAuth access token
   */
  requireAccessToken() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const tokenExpireThreshold = new Date(_Date$now() - 60000); // Take 1 minute from the current time just to be safe
      const {
        accessToken,
        accessTokenExpiry,
        nonce,
        refreshToken,
        token
      } = _this;
      if (typeof accessToken !== 'string') {
        return _this.getAccessToken(nonce, token);
      } else if (!accessTokenExpiry || accessTokenExpiry <= tokenExpireThreshold) {
        return _this.refreshAccessToken(nonce, refreshToken);
      }
      return accessToken;
    })();
  }
  /**
   * Create a new oAuth access token.
   *
   * @param nonce - A nonce value for the request
   * @param token - A single use token to be exchanged for an oAuth access token
   *
   * @returns A newly created oAuth access token
   */
  getAccessToken(nonce, token) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      const data = yield createOAuthToken({
        nonce,
        token
      });
      _this2.accessToken = data.accessToken;
      _this2.accessTokenExpiry = data.expires;
      _this2.refreshToken = data.refreshToken;
      return data.accessToken;
    })();
  }
  /**
   * Refresh an expired or nearly expired oAuth access token.
   *
   * @param nonce - A nonce value for the request
   * @param refreshToken - A token to be used for refreshing the oAuth access token
   *
   * @returns A newly created oAuth access token
   */
  refreshAccessToken(nonce, refreshToken) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      const data = yield refreshOAuthToken({
        nonce,
        refreshToken
      });
      _this3.accessToken = data.accessToken;
      _this3.accessTokenExpiry = data.expires;
      _this3.refreshToken = data.refreshToken;
      return data.accessToken;
    })();
  }
}

class ScheduledPaymentFlow extends OAuthFlow {
  /**
   * Creates a flow to create a scheduled payment.
   *
   * @param nonce - A nonce value for the requests
   * @param token - A single use token to be exchanged for an oAuth access token
   * @param initialAuth - An optional parameter with previously fetched oAuth details
   *
   * @example
   * ```javascript
   * import { ScheduledPaymentFlow } from '@thisisbud/internal-sdk'
   *
   * const so = new ScheduledPaymentFlow('38158fa9baa47bfde34f', '1f47a0edbde64d06ac528d59b87975acc6830dbd')
   * ```
   */
  constructor(nonce, token, initialAuth) {
    // This exists just to be able to document the constructor of the class
    super(nonce, token, initialAuth);
  }
  /**
   * Get the details for the scheduled payment.
   *
   * @returns Details for the scheduled payment
   * @public
   *
   * @example
   * ```javascript
   * const result = await sp.getDetails()
   * ```
   */
  getDetails() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const nonce = _this.nonce;
      const accessToken = yield _this.requireAccessToken();
      return getScheduledPaymentDetails({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Get a list of available providers for the scheduled payment.
   *
   * @returns A list of available providers to use
   * @public
   *
   * @example
   * ```javascript
   * const result = await sp.getProviders()
   * ```
   */
  getProviders() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this2.nonce;
      const accessToken = yield _this2.requireAccessToken();
      return getScheduledPaymentProviders({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Set a provider to handle the scheduled payment.
   *
   * @param providerId - The ID of the provider to set
   * @public
   *
   * @example
   * ```javascript
   * await sp.setProvider('lloyds')
   * ```
   */
  setProvider(providerId) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this3.nonce;
      const accessToken = yield _this3.requireAccessToken();
      yield setScheduledPaymentProvider({
        accessToken,
        nonce
      }, providerId);
    })();
  }
  /**
   * Get a URL to authorize the payment with the selected provider.
   *
   * @returns A URL to use for authorizing the payment with the provider
   * @public
   *
   * @example
   * ```javascript
   * const result = await sp.getAuthorizationUrl()
   * ```
   */
  getAuthorizationUrl() {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this4.nonce;
      const accessToken = yield _this4.requireAccessToken();
      return getScheduledPaymentAuthorizationUrl({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Get the status associated with the payment.
   *
   * @returns An object containing the status and extra charges associated with the payment
   *
   * @example
   * ```javascript
   * const result = await so.getPaymentStatus()
   * {
   *    extraCharges: 2.5,
   *    status: 'Pending Completion',
   * }
   * ```
   */
  getPaymentStatus() {
    var _this5 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this5.nonce;
      const accessToken = yield _this5.requireAccessToken();
      return getScheduledPaymentStatus({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Confirm a scheduled payment.
   *
   * @public
   *
   * @example
   * ```javascript
   * await sp.confirm()
   * ```
   */
  confirm() {
    var _this6 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this6.nonce;
      const accessToken = yield _this6.requireAccessToken();
      yield confirmScheduledPayment({
        accessToken,
        nonce
      });
    })();
  }
}

class StandingOrderFlow extends OAuthFlow {
  /**
   * Creates a flow to create a standing order payment.
   *
   * @param nonce - A nonce value for the requests
   * @param token - A single use token to be exchanged for an oAuth access token
   * @param initialAuth - An optional parameter with previously fetched oAuth details
   *
   * @example
   * ```javascript
   * import { StandingOrderFlow } from '@thisisbud/internal-sdk'
   *
   * const so = new StandingOrderFlow('38158fa9baa47bfde34f', '1f47a0edbde64d06ac528d59b87975acc6830dbd')
   * ```
   */
  constructor(nonce, token, initialAuth) {
    // This exists just to be able to document the constructor of the class
    super(nonce, token, initialAuth);
  }
  /**
   * Get the details for the standing order.
   *
   * @returns Details for the standing order
   * @public
   *
   * @example
   * ```javascript
   * const result = await so.getDetails()
   * ```
   */
  getDetails() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const nonce = _this.nonce;
      const accessToken = yield _this.requireAccessToken();
      return getStandingOrderDetails({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Get a list of available providers for the standing order.
   *
   * @returns A list of available providers to use
   * @public
   *
   * @example
   * ```javascript
   * const result = await so.getProviders()
   * ```
   */
  getProviders() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this2.nonce;
      const accessToken = yield _this2.requireAccessToken();
      return getStandingOrderProviders({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Set a provider to handle the standing order.
   *
   * @param providerId - The ID of the provider to set
   * @public
   *
   * @example
   * ```javascript
   * await so.setProvider('lloyds')
   * ```
   */
  setProvider(providerId) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this3.nonce;
      const accessToken = yield _this3.requireAccessToken();
      yield setStandingOrderProvider({
        accessToken,
        nonce
      }, providerId);
    })();
  }
  /**
   * Get a URL to authorize the payment with the selected provider.
   *
   * @returns A URL to use for authorizing the payment with the provider
   * @public
   *
   * @example
   * ```javascript
   * const result = await so.getAuthorizationUrl()
   * ```
   */
  getAuthorizationUrl() {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this4.nonce;
      const accessToken = yield _this4.requireAccessToken();
      return getStandingOrderAuthorizationUrl({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Get the status associated with the payment.
   *
   * @returns An object containing the status and extra charges associated with the payment
   *
   * @example
   * ```javascript
   * const result = await so.getPaymentStatus()
   * {
   *    extraCharges: 2.5,
   *    status: 'Pending Completion',
   * }
   * ```
   */
  getPaymentStatus() {
    var _this5 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this5.nonce;
      const accessToken = yield _this5.requireAccessToken();
      return getStandingOrderStatus({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Confirm a standing order.
   *
   * @public
   *
   * @example
   * ```javascript
   * await so.confirm()
   * ```
   */
  confirm() {
    var _this6 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this6.nonce;
      const accessToken = yield _this6.requireAccessToken();
      yield confirmStandingOrder({
        accessToken,
        nonce
      });
    })();
  }
}

class SinglePaymentFlow extends OAuthFlow {
  /**
   * Creates a flow to create a single payment.
   *
   * @param nonce - A nonce value for the requests
   * @param token - A single use token to be exchanged for an oAuth access token
   * @param initialAuth - An optional parameter with previously fetched oAuth details
   *
   * @example
   * ```javascript
   * import { SinglePaymentFlow } from '@thisisbud/internal-sdk'
   *
   * const sp = new SinglePaymentFlow('38158fa9baa47bfde34f', '1f47a0edbde64d06ac528d59b87975acc6830dbd')
   * ```
   */
  constructor(nonce, token, initialAuth) {
    // This exists just to be able to document the constructor of the class
    super(nonce, token, initialAuth);
  }
  /**
   * Get the details for the single payment.
   *
   * @returns Details for the single payment
   * @public
   *
   * @example
   * ```javascript
   * const result = await sp.getDetails()
   * ```
   */
  getDetails() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const nonce = _this.nonce;
      const accessToken = yield _this.requireAccessToken();
      return getSinglePaymentDetails({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Get a list of available providers for the single payment.
   *
   * @returns A list of available providers to use
   * @public
   *
   * @example
   * ```javascript
   * const result = await sp.getProviders()
   * ```
   */
  getProviders() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this2.nonce;
      const accessToken = yield _this2.requireAccessToken();
      return getSinglePaymentProviders({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Set a provider to handle the single payment.
   *
   * @param providerId - The ID of the provider to set
   * @public
   *
   * @example
   * ```javascript
   * await sp.setProvider('lloyds')
   * ```
   */
  setProvider(providerId) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this3.nonce;
      const accessToken = yield _this3.requireAccessToken();
      yield setSinglePaymentProvider({
        accessToken,
        nonce
      }, providerId);
    })();
  }
  /**
   * Get a single payment required fields for a given provider.
   *
   * @returns A list of required fields for the provider
   * @public
   *
   * @example
   * ```javascript
   * await sp.getProviderRequiredFields()
   * ```
   */
  getProviderRequiredFields() {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this4.nonce;
      const accessToken = yield _this4.requireAccessToken();
      return getSinglePaymentProviderRequiredFields({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Set single payment field values for a given provider.
   *
   * @param fields - The fields to update on the single payment
   * @public
   *
   * @example
   * ```javascript
   * await sp.setProviderFieldValues({
   *  iban: 'NL49RABO5350244469',
   *  account_holder_name: 'John Doe'
   * })
   * ```
   */
  setProviderFieldValues(fields) {
    var _this5 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this5.nonce;
      const accessToken = yield _this5.requireAccessToken();
      yield setSinglePaymentProviderFieldValues({
        accessToken,
        nonce
      }, fields);
    })();
  }
  /**
   * Get a URL to authorize the payment with the selected provider.
   *
   * @returns A URL to use for authorizing the payment with the provider
   * @public
   *
   * @example
   * ```javascript
   * const result = await sp.getAuthorizationUrl()
   * ```
   */
  getAuthorizationUrl() {
    var _this6 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this6.nonce;
      const accessToken = yield _this6.requireAccessToken();
      return getSinglePaymentAuthorizationUrl({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Get the status associated with the payment.
   *
   * @returns An object containing the status and extra charges associated with the payment
   *
   * @example
   * ```javascript
   * const result = await so.getPaymentStatus()
   * {
   *    extraCharges: 2.5,
   *    status: 'Pending Completion',
   * }
   * ```
   */
  getPaymentStatus() {
    var _this7 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this7.nonce;
      const accessToken = yield _this7.requireAccessToken();
      return getSinglePaymentStatus({
        accessToken,
        nonce
      });
    })();
  }
  /**
   * Confirm a single payment.
   *
   * @public
   *
   * @example
   * ```javascript
   * await sp.confirm()
   * ```
   */
  confirm() {
    var _this8 = this;
    return _asyncToGenerator(function* () {
      const nonce = _this8.nonce;
      const accessToken = yield _this8.requireAccessToken();
      yield confirmSinglePayment({
        accessToken,
        nonce
      });
    })();
  }
}

export { HttpError, MeetingReviewStatus, Namespace, PaymentErrorCode, PaymentFrequency, PaymentStatusCode, ScheduledPaymentFlow, SinglePaymentFlow, StandingOrderFlow, Version, accountHasConsecutiveDaysOfData, batchIngestAccountStatements, confirmOpenBankingConnection, confirmScheduledPayment, confirmSinglePayment, confirmStandingOrder, createAgentFlowOAuthToken, createMeeting, createMeetingOAuthToken, createOAuthToken, deleteMeetingFinancialData, formatAccount, formatAgentFlowOAuthTokenResponse, formatGetAccountProvidersResponse, formatGetAccountsResponse, formatGetAffordabilityDashboardConfig, formatGetAffordabilityDashboardConfigList, formatGetAgentFlowConfigResponse, formatGetIngestAccountStatementStatusResponse, formatGetIngestedAccountStatementsResponse, formatGetMeetingDetailsResponse, formatGetMeetingReportResponse, formatGetMeetingTransactionsResponse, formatGetMeetingsResponse, formatGetOpenBankingConnectStatusResponse, formatGetPaymentAuthorizationUrlResponse, formatGetPaymentProvidersResponse, formatGetPaymentStatusResponse, formatGetProviderAuthorizationUrlStatusResponse, formatGetProviderLoginFormResponse, formatGetProviderRequiredFieldsResponse, formatGetScheduledPaymentDetailsResponse, formatGetSinglePaymentDetailsResponse, formatGetStandingOrderDetailsResponse, formatGetTransactionCategoriesResponse, formatGetTransactionTotalsResponse, formatL1TransactionCategory, formatL2TransactionCategory, formatMeetingDetails, formatMeetingReport, formatMeetingTransaction, formatPostIngestAccountStatementResponse, formatPostOAuthTokenResponse, formatTransactionTotals$1 as formatTransactionTotals, formatTransactionTotalsGroup$1 as formatTransactionTotalsGroup, getAccountMaxConsecutiveDaysOfData, getAccountProviders, getAccountVerificationProviderAuthorizationUrl, getAccountVerificationProviderAuthorizationUrlStatus, getAccountVerificationProviders, getAccounts, getAccountsWithConsecutiveDaysOfData, getAccountsWithoutConsecutiveDaysOfData, getAffordabilityDashboardConfig, getAgentFlowConfig, getHost, getIngestAccountStatementStatus, getIngestedAccountStatements, getMeetingDetails, getMeetingReport, getMeetingTransactionTotals, getMeetingTransactions, getMeetings, getOpenBankingConnectStatus, getOpenBankingProviderAuthorizationUrl, getOpenBankingProviderAuthorizationUrlStatus, getOpenBankingProviders, getOtherIncomeMeetingTransactions, getOverallAccountsTransactionWindow, getPollingInterval, getScheduledPaymentAuthorizationUrl, getScheduledPaymentDetails, getScheduledPaymentProviders, getScheduledPaymentStatus, getScrapingProviderLoginForm, getScrapingProviders, getSimilarMeetingTransactions, getSinglePaymentAuthorizationUrl, getSinglePaymentDetails, getSinglePaymentProviderRequiredFields, getSinglePaymentProviders, getSinglePaymentStatus, getStandingOrderAuthorizationUrl, getStandingOrderDetails, getStandingOrderProviders, getStandingOrderStatus, getStatementIngestionProviders, getTransactionCategories, groupAccountsByProvider, groupAccountsBySubType, groupMeetingsByDate, ingestAccountStatement, initIngestAccountStatements, mergeTransactionWindowsWithThreshold, refreshAgentFlowOAuthToken, refreshMeetingOAuthToken, refreshOAuthToken, request, setHost, setPollingInterval, setScheduledPaymentProvider, setSinglePaymentProvider, setSinglePaymentProviderFieldValues, setStandingOrderProvider, updateMeetingDetails, updateMeetingTransactions };
